
// // // // // ////previous hero
// // // // // // import { ArrowRight } from "lucide-react";
// // // // // // import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// // // // // // import { useRef } from "react";

// // // // // // const NAVBAR_HEIGHT = 96;

// // // // // // const smoothSpring = {
// // // // // //   stiffness: 40,
// // // // // //   damping: 30,
// // // // // //   mass: 1.2,
// // // // // // };

// // // // // // const HeroSection = () => {
// // // // // //   const scrollRef = useRef(null);

// // // // // //   const { scrollYProgress } = useScroll({
// // // // // //     target: scrollRef,
// // // // // //     offset: ["start start", "end end"],
// // // // // //   });

// // // // // //   /* ---------------- TEXT ---------------- */
// // // // // //   const textY = useSpring(
// // // // // //     useTransform(scrollYProgress, [0, 0.15], [0, -120]),
// // // // // //     smoothSpring
// // // // // //   );

// // // // // //   const textOpacity = useSpring(
// // // // // //     useTransform(scrollYProgress, [0, 0.2], [1, 0]),
// // // // // //     smoothSpring
// // // // // //   );

// // // // // //   /* ---------------- LAPTOP MOTION ---------------- */
// // // // // //   // Start very large so screen feels fullscreen
// // // // // //   const laptopScale = useSpring(
// // // // // //     useTransform(scrollYProgress, [0, 0.35], [1.8, 1]),
// // // // // //     smoothSpring
// // // // // //   );

// // // // // //   // const laptopY = useSpring(
// // // // // //   //   useTransform(scrollYProgress, [0, 0.55], [80, 350]),
// // // // // //   //   smoothSpring
// // // // // //   // );


// // // // // //   const laptopY = useSpring(
// // // // // //   useTransform(scrollYProgress, [0, 0.42], [80, 350]),
// // // // // //   smoothSpring
// // // // // // );



// // // // // //   return (
// // // // // //     <section
// // // // // //       className="relative bg-black"
// // // // // //       style={{ paddingTop: NAVBAR_HEIGHT }}
// // // // // //     >
// // // // // //       {/* SCROLL TRACK */}
// // // // // //       <div ref={scrollRef} className="relative h-[220vh]">

// // // // // //         {/* STICKY STAGE */}
// // // // // //         <div className="sticky top-[96px] h-[calc(800vh-96px)] overflow-hidden">

// // // // // //           {/* ---------------- TEXT ---------------- */}
// // // // // //           <motion.div
// // // // // //             style={{ y: textY, opacity: textOpacity }}
// // // // // //             className="relative z-20 text-center max-w-4xl mx-auto px-6 pt-32 text-white"
// // // // // //           >
// // // // // //             <h1 className="text-[44px] md:text-[56px] lg:text-[64px] font-semibold leading-[1.05]">
// // // // // //               The smarter way
// // // // // //               <br />
// // // // // //               to run your
// // // // // //               <br />
// // // // // //               legal practice
// // // // // //             </h1>

// // // // // //             <p className="mt-8 text-lg md:text-xl text-gray-300 max-w-xl mx-auto">
// // // // // //               A modern legal platform to manage cases, clients,
// // // // // //               documents, and payments — effortlessly.
// // // // // //             </p>

// // // // // //             <div className="mt-10 flex items-center justify-center gap-6">
// // // // // //               <button className="px-8 py-4 rounded-full bg-white text-black text-sm font-medium">
// // // // // //                 Get started
// // // // // //               </button>

// // // // // //               <span className="flex items-center gap-2 text-sm text-gray-300">
// // // // // //                 See how it works <ArrowRight className="w-4 h-4" />
// // // // // //               </span>
// // // // // //             </div>
// // // // // //           </motion.div>

// // // // // //           {/* ---------------- LAPTOP (PHONE-LIKE PATTERN) ---------------- */}
// // // // // //           <motion.div
// // // // // //             style={{
// // // // // //               scale: laptopScale,
// // // // // //               y: laptopY,
// // // // // //               opacity: 1,
// // // // // //             }}
// // // // // //             className="
// // // // // //               absolute

// // // // // //               bottom-[80%]
// // // // // //               left-[6%]
// // // // // //               width-[100%]
// // // // // //               will-change-transform
// // // // // //             "
// // // // // //           >
// // // // // //             {/* LAPTOP WRAPPER */}
// // // // // //             <div className="relative w-[1300px] max-w-[90vw]">

// // // // // //               {/* ---------------- SCREEN ---------------- */}
// // // // // //               <div
// // // // // //                 className="
// // // // // //                   absolute
// // // // // //                   top-[27.5%]
// // // // // //                   left-[17.4%]
// // // // // //                   w-[65%]
// // // // // //                   h-[43%]
// // // // // //                   z-10
// // // // // //                   overflow-hidden
// // // // // //                   rounded-[14px]
// // // // // //                   bg-black
// // // // // //                 "
// // // // // //               >
// // // // // //                 {/* VIDEO ALWAYS LIVES HERE */}
// // // // // //                 {/* <video
// // // // // //                   src="/Valsco.mp4"
// // // // // //                   autoPlay
// // // // // //                   muted
// // // // // //                   loop
// // // // // //                   playsInline
// // // // // //                   className="relative z-20 w-full h-full object-cover"
// // // // // //                 /> */}
// // // // // //               </div>

// // // // // //               {/* ---------------- FRAME ---------------- */}
// // // // // //               <img
// // // // // //                 src="/laptoptrans.png"
// // // // // //                 alt="Laptop frame"
// // // // // //                 className="relative w-900 pointer-events-none drop-shadow-[0_80px_160px_rgba(0,0,0,0.45)]"
// // // // // //               />
// // // // // //             </div>
// // // // // //           </motion.div>

// // // // // //         </div>
// // // // // //       </div>
// // // // // //     </section>
// // // // // //   );
// // // // // // };

// // // // // // export default HeroSection;







// // // // // // import { ArrowRight } from "lucide-react";
// // // // // // import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// // // // // // import { useRef } from "react";

// // // // // // const NAVBAR_HEIGHT = 96;

// // // // // // const smoothSpring = {
// // // // // //   stiffness: 40,
// // // // // //   damping: 30,
// // // // // //   mass: 1.2,
// // // // // // };

// // // // // // const HeroSection = () => {
// // // // // //   const scrollRef = useRef(null);

// // // // // //   const { scrollYProgress } = useScroll({
// // // // // //     target: scrollRef,
// // // // // //     offset: ["start start", "end end"],
// // // // // //   });

// // // // // //   /* ---------------- TEXT ---------------- */
// // // // // //   const textY = useSpring(
// // // // // //     useTransform(scrollYProgress, [0, 0.15], [0, -120]),
// // // // // //     smoothSpring
// // // // // //   );

// // // // // //   const textOpacity = useSpring(
// // // // // //     useTransform(scrollYProgress, [0, 0.2], [1, 0]),
// // // // // //     smoothSpring
// // // // // //   );

// // // // // //   /* ---------------- LAPTOP MOTION ---------------- */
// // // // // //   const laptopScale = useSpring(
// // // // // //     useTransform(scrollYProgress, [0, 0.35], [1.8, 1]),
// // // // // //     smoothSpring
// // // // // //   );

// // // // // //   const laptopY = useSpring(
// // // // // //     useTransform(scrollYProgress, [0, 0.42], [80, 350]),
// // // // // //     smoothSpring
// // // // // //   );

// // // // // //   /* 🔑 FADE LAPTOP BEFORE EXIT */
// // // // // //   const laptopOpacity = useSpring(
// // // // // //     useTransform(scrollYProgress, [0.45, 0.6], [1, 0]),
// // // // // //     smoothSpring
// // // // // //   );

// // // // // //   return (
// // // // // //     <section
// // // // // //       className="relative bg-black"
// // // // // //       style={{ paddingTop: NAVBAR_HEIGHT }}
// // // // // //     >
// // // // // //       {/* SCROLL TRACK */}
// // // // // //       <div ref={scrollRef} className="relative h-[200vh]">
// // // // // //         {/* STICKY STAGE */}
// // // // // //         <div className="sticky top-[96px] h-[calc(100vh-96px)] overflow-hidden">
          
// // // // // //           {/* ---------------- TEXT ---------------- */}
// // // // // //           <motion.div
// // // // // //             style={{ y: textY, opacity: textOpacity }}
// // // // // //             className="relative z-20 text-center max-w-4xl mx-auto px-6 pt-32 text-white"
// // // // // //           >
// // // // // //             <h1 className="text-[44px] md:text-[56px] lg:text-[64px] font-semibold leading-[1.05]">
// // // // // //               The smarter way
// // // // // //               <br />
// // // // // //               to run your
// // // // // //               <br />
// // // // // //               legal practice
// // // // // //             </h1>

// // // // // //             <p className="mt-8 text-lg md:text-xl text-gray-300 max-w-xl mx-auto">
// // // // // //               A modern legal platform to manage cases, clients,
// // // // // //               documents, and payments — effortlessly.
// // // // // //             </p>

// // // // // //             <div className="mt-10 flex items-center justify-center gap-6">
// // // // // //               <button className="px-8 py-4 rounded-full bg-white text-black text-sm font-medium">
// // // // // //                 Get started
// // // // // //               </button>

// // // // // //               <span className="flex items-center gap-2 text-sm text-gray-300">
// // // // // //                 See how it works <ArrowRight className="w-4 h-4" />
// // // // // //               </span>
// // // // // //             </div>
// // // // // //           </motion.div>

// // // // // //           {/* ---------------- LAPTOP ---------------- */}
// // // // // //           <motion.div
// // // // // //             style={{
// // // // // //               scale: laptopScale,
// // // // // //               y: laptopY,
// // // // // //               opacity: laptopOpacity,
// // // // // //             }}
// // // // // //             className="
// // // // // //               absolute
// // // // // //               bottom-[75%]
// // // // // //               left-[6%]
// // // // // //               w-full
// // // // // //               will-change-transform
// // // // // //             "
// // // // // //           >
// // // // // //             <div className="relative w-[1300px] max-w-[90vw]">
// // // // // //               <div
// // // // // //                 className="
// // // // // //                   absolute
// // // // // //                   top-[27.5%]
// // // // // //                   left-[17.4%]
// // // // // //                   w-[65%]
// // // // // //                   h-[43%]
// // // // // //                   z-10
// // // // // //                   overflow-hidden
// // // // // //                   rounded-[14px]
// // // // // //                   bg-black
// // // // // //                 "
// // // // // //               />

// // // // // //               <img
// // // // // //                 src="/laptoptrans.png"
// // // // // //                 alt="Laptop frame"
// // // // // //                 className="relative pointer-events-none drop-shadow-[0_80px_160px_rgba(0,0,0,0.45)]"
// // // // // //               />
// // // // // //             </div>
// // // // // //           </motion.div>

// // // // // //         </div>
// // // // // //       </div>
// // // // // //     </section>
// // // // // //   );
// // // // // // };

// // // // // // export default HeroSection;


















// // // // // // import { ArrowRight } from "lucide-react";
// // // // // // import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// // // // // // import { useRef } from "react";

// // // // // // const NAVBAR_HEIGHT = 96;

// // // // // // const smoothSpring = {
// // // // // //   stiffness: 40,
// // // // // //   damping: 30,
// // // // // //   mass: 1.2,
// // // // // // };

// // // // // // const HeroSection = () => {
// // // // // //   const scrollRef = useRef(null);

// // // // // //   const { scrollYProgress } = useScroll({
// // // // // //     target: scrollRef,
// // // // // //     offset: ["start start", "end end"],
// // // // // //   });

// // // // // //   const textY = useSpring(
// // // // // //     useTransform(scrollYProgress, [0, 0.15], [0, -120]),
// // // // // //     smoothSpring
// // // // // //   );

// // // // // //   const textOpacity = useSpring(
// // // // // //     useTransform(scrollYProgress, [0, 0.2], [1, 0]),
// // // // // //     smoothSpring
// // // // // //   );

// // // // // //   const laptopScale = useSpring(
// // // // // //     useTransform(scrollYProgress, [0, 0.35], [1.8, 1]),
// // // // // //     smoothSpring
// // // // // //   );

// // // // // //   const laptopY = useSpring(
// // // // // //     useTransform(scrollYProgress, [0, 0.42], [80, 350]),
// // // // // //     smoothSpring
// // // // // //   );

// // // // // //   const laptopOpacity = useSpring(
// // // // // //     useTransform(scrollYProgress, [0.45, 0.6], [1, 0]),
// // // // // //     smoothSpring
// // // // // //   );

// // // // // //   return (
// // // // // //     <section className="relative bg-black" style={{ paddingTop: NAVBAR_HEIGHT }}>
// // // // // //       <div ref={scrollRef} className="relative h-[200vh]">
// // // // // //         <div className="sticky top-[96px] h-[calc(100vh-96px)] overflow-hidden">

// // // // // //           <motion.div
// // // // // //             style={{ y: textY, opacity: textOpacity }}
// // // // // //             className="relative z-20 text-center max-w-4xl mx-auto px-6 pt-32 text-white"
// // // // // //           >
// // // // // //             <h1 className="text-[48px] md:text-[64px] lg:text-[72px] font-semibold tracking-tight leading-[1.02]">
// // // // // //               The smarter way
// // // // // //               <br />
// // // // // //               to run your
// // // // // //               <br />
// // // // // //               legal practice
// // // // // //             </h1>

// // // // // //             <p className="mt-8 text-lg md:text-xl text-white/70 max-w-xl mx-auto">
// // // // // //               A modern legal platform to manage cases, clients,
// // // // // //               documents, and payments — effortlessly.
// // // // // //             </p>

// // // // // //             <div className="mt-10 flex items-center justify-center gap-6">
// // // // // //               <button className="px-9 py-4 rounded-full bg-white text-black text-sm font-medium hover:scale-[1.04] transition">
// // // // // //                 Get started
// // // // // //               </button>

// // // // // //               <span className="flex items-center gap-2 text-sm text-white/60">
// // // // // //                 See how it works <ArrowRight className="w-4 h-4" />
// // // // // //               </span>
// // // // // //             </div>
// // // // // //           </motion.div>

// // // // // //           <motion.div
// // // // // //             style={{ scale: laptopScale, y: laptopY, opacity: laptopOpacity }}
// // // // // //             className="absolute bottom-[75%] left-[6%] w-full"
// // // // // //           >
// // // // // //             <div className="relative w-[1300px] max-w-[90vw]">
// // // // // //               <div className="absolute top-[27.5%] left-[17.4%] w-[65%] h-[43%] rounded-[14px] bg-black" />
// // // // // //               <img
// // // // // //                 src="/laptoptrans.png"
// // // // // //                 className="relative pointer-events-none drop-shadow-[0_80px_160px_rgba(0,0,0,0.45)]"
// // // // // //                 alt=""
// // // // // //               />
// // // // // //             </div>
// // // // // //           </motion.div>

// // // // // //         </div>
// // // // // //       </div>
// // // // // //     </section>
// // // // // //   );
// // // // // // };

// // // // // // export default HeroSection;




































// // // // // //final code with outline div perfect code
// // // // // import {
// // // // //   motion,
// // // // //   useScroll,
// // // // //   useTransform,
// // // // //   useSpring
// // // // // } from "framer-motion";
// // // // // import { useRef, useState, useEffect } from "react";

// // // // // const FEATURES = [
// // // // //   { title: "Dashboard", image: "/legal.png" },
// // // // //   { title: "All Cases", image: "/casemanage.png" },
// // // // //   { title: "Calendar", image: "/calander.png" },
// // // // //   { title: "Export Cases", image: "/Home.png" },
// // // // //   { title: "Expenses", image: "/expenses.png" }
// // // // // ];

// // // // // export default function Features() {

// // // // //   const outerScrollRef = useRef(null);
// // // // //   const laptopScrollRef = useRef(null);
// // // // //   const [active,setActive] = useState(0);

// // // // //   const { scrollYProgress } = useScroll({
// // // // //     container:laptopScrollRef
// // // // //   });

// // // // //   const progressHeight = useSpring(
// // // // //     useTransform(scrollYProgress,[0,1],["0%","100%"]),
// // // // //     { stiffness:120,damping:30 }
// // // // //   );

// // // // //   useEffect(()=>{

// // // // //     const outer = outerScrollRef.current;
// // // // //     const laptop = laptopScrollRef.current;

// // // // //     if(!outer || !laptop) return;

// // // // //     const handleOuterScroll = () => {

// // // // //       const maxOuter = outer.scrollHeight - outer.clientHeight;
// // // // //       if(maxOuter <=0) return;

// // // // //       let progress = outer.scrollTop / maxOuter;
// // // // //       progress = Math.min(Math.max(progress,0),1);

// // // // //       const maxLaptop = laptop.scrollHeight - laptop.clientHeight;
// // // // //       laptop.scrollTop = progress * maxLaptop;

// // // // //       const index = Math.round(progress * (FEATURES.length-1));
// // // // //       setActive(index);
// // // // //     };

// // // // //     outer.addEventListener("scroll",handleOuterScroll);
// // // // //     return ()=>outer.removeEventListener("scroll",handleOuterScroll);

// // // // //   },[]);

// // // // //   return(

// // // // // <section className="relative py-20 bg-gradient-to-b from-[#fafafa] via-[#f1f5f9] to-[#ffffff] overflow-hidden">

// // // // // <style>{`
// // // // // .hide-scrollbar::-webkit-scrollbar{
// // // // // display:none;
// // // // // }
// // // // // .hide-scrollbar{
// // // // // -ms-overflow-style:none;
// // // // // scrollbar-width:none;
// // // // // }
// // // // // `}</style>

// // // // // {/* Background Lights */}

// // // // // <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[1500px] h-[750px] bg-indigo-300/20 blur-[220px] rounded-full"/>

// // // // // <div className="absolute bottom-0 right-0 w-[750px] h-[650px] bg-yellow-200/20 blur-[200px] rounded-full"/>

// // // // // <div className="absolute bottom-0 left-0 w-[650px] h-[550px] bg-blue-200/20 blur-[200px] rounded-full"/>


// // // // // <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 items-center gap-28">

// // // // // {/* LEFT SIDE */}

// // // // // <div>

// // // // // <h2 className="text-6xl font-semibold leading-tight text-gray-900 tracking-tight">
// // // // // We are not limited to just a Application!
// // // // // </h2>

// // // // // <p className="mt-6 text-lg text-gray-600 max-w-md leading-relaxed">
// // // // // Manage cases, schedules, and documents with precision.  
// // // // // Jurident simplifies every part of your practice with
// // // // // a seamless experience.
// // // // // </p>

// // // // // <div className="mt-14 space-y-7">

// // // // // {FEATURES.map((f,i)=>(
// // // // // <motion.div
// // // // // key={i}
// // // // // animate={{
// // // // // opacity:active===i?1:0.4,
// // // // // x:active===i?14:0
// // // // // }}
// // // // // transition={{ duration:0.35 }}
// // // // // className="flex items-center gap-4"
// // // // // >

// // // // // <div className={`w-3.5 h-3.5 rounded-full transition-all duration-300 ${
// // // // // active===i
// // // // // ? "bg-gradient-to-r from-yellow-400 to-orange-400 shadow-[0_0_12px_rgba(255,180,50,0.7)]"
// // // // // : "bg-gray-300"
// // // // // }`} />

// // // // // <p className={`text-lg transition-all duration-300 ${
// // // // // active===i
// // // // // ? "font-semibold text-black"
// // // // // : "text-gray-500"
// // // // // }`}>
// // // // // {f.title}
// // // // // </p>

// // // // // </motion.div>
// // // // // ))}

// // // // // </div>

// // // // // <motion.button
// // // // // whileHover={{ scale:1.06 }}
// // // // // whileTap={{ scale:0.97 }}
// // // // // className="mt-12 px-9 py-3 rounded-full bg-black text-white font-medium shadow-xl hover:shadow-2xl transition"
// // // // // >
// // // // // Get Started →
// // // // // </motion.button>

// // // // // </div>


// // // // // {/* RIGHT SIDE */}

// // // // // <div className="relative flex justify-center overflow-visible">

// // // // // {/* Rotating Halo */}

// // // // // <motion.div
// // // // // animate={{ rotate:360 }}
// // // // // transition={{ repeat:Infinity,duration:55,ease:"linear" }}
// // // // // className="absolute w-[780px] h-[780px] rounded-full bg-gradient-to-r from-indigo-200/30 via-blue-200/30 to-yellow-200/30 blur-[140px]"
// // // // // />

// // // // // {/* Scroll Trigger */}


// // // // // <div
// // // // // ref={outerScrollRef}
// // // // // className="relative h-[650px] w-[900px] -left-[100px] overflow-y-scroll hide-scrollbar"
// // // // // >
// // // // // <div className="h-[4000px]" />
// // // // // </div>

// // // // // {/* Laptop Container With Outline */}

// // // // // <div className="absolute inset-0 flex items-center justify-center pointer-events-none">

// // // // // <div className="relative outline outline-1 outline-gray-300/60 rounded-2xl p-6">

// // // // // <motion.div
// // // // // initial={{ scale:1 }}
// // // // // whileHover={{
// // // // // scale:1.12,
// // // // // rotateX:10,
// // // // // rotateY:-10,
// // // // // y:-25
// // // // // }}
// // // // // transition={{
// // // // // type:"spring",
// // // // // stiffness:200,
// // // // // damping:20
// // // // // }}
// // // // // style={{ perspective:1400 }}
// // // // // >

// // // // // <div className="relative">

// // // // // {/* Glow */}

// // // // // <div className="absolute -inset-24 bg-gradient-to-r from-indigo-400/20 via-blue-300/20 to-yellow-300/20 blur-[140px] rounded-full"/>

// // // // // <img
// // // // // src="/laptoptrans.png"
// // // // // className="relative w-[700px] max-w-none drop-shadow-[0_120px_200px_rgba(0,0,0,0.5)] hover:drop-shadow-[0_160px_260px_rgba(0,0,0,0.6)] transition-all duration-500"
// // // // // />

// // // // // {/* Laptop Screen */}

// // // // // <div
// // // // //   ref={laptopScrollRef}
// // // // //   className="absolute top-[27%] left-[17.5%] w-[65%] h-[43%] overflow-y-auto rounded-xl 
// // // // //   bg-black hide-scrollbar shadow-inner 
// // // // //   border border-white/15 ring-1 ring-black/40"
// // // // // >

// // // // // {FEATURES.map((f,i)=>(
// // // // // <img
// // // // // key={i}
// // // // // src={f.image}
// // // // // className="w-full h-full object-cover"
// // // // // />
// // // // // ))}

// // // // // </div>

// // // // // </div>

// // // // // </motion.div>

// // // // // </div>

// // // // // </div>


// // // // // {/* Progress Indicator */}

// // // // // <div className="absolute right-[-35px] top-1/2 -translate-y-1/2 h-[340px] w-[3px] bg-gray-200 rounded-full overflow-hidden">

// // // // // <motion.div
// // // // // className="w-full bg-gradient-to-b from-yellow-400 to-orange-400"
// // // // // style={{ height:progressHeight }}
// // // // // />

// // // // // </div>


// // // // // </div>

// // // // // </div>

// // // // // </section>
// // // // //   );
// // // // // }









// // // // // import {
// // // // //   motion,
// // // // //   useScroll,
// // // // //   useTransform,
// // // // //   useSpring
// // // // // } from "framer-motion";
// // // // // import { useRef, useState, useEffect } from "react";

// // // // // const FEATURES = [
// // // // //   { title: "Dashboard", image: "/legal.png" },
// // // // //   { title: "All Cases", image: "/casemanage.png" },
// // // // //   { title: "Calendar", image: "/calander.png" },
// // // // //   { title: "Export Cases", image: "/Home.png" },
// // // // //   { title: "Expenses", image: "/expenses.png" }
// // // // // ];

// // // // // export default function Features() {

// // // // //   const outerScrollRef = useRef(null);
// // // // //   const laptopScrollRef = useRef(null);
// // // // //   const [active,setActive] = useState(0);

// // // // //   const { scrollYProgress } = useScroll({
// // // // //     container:laptopScrollRef
// // // // //   });

// // // // //   const progressHeight = useSpring(
// // // // //     useTransform(scrollYProgress,[0,1],["0%","100%"]),
// // // // //     { stiffness:120,damping:30 }
// // // // //   );

// // // // //   useEffect(()=>{

// // // // //     const outer = outerScrollRef.current;
// // // // //     const laptop = laptopScrollRef.current;

// // // // //     if(!outer || !laptop) return;

// // // // //     const handleOuterScroll = () => {

// // // // //       const maxOuter = outer.scrollHeight - outer.clientHeight;
// // // // //       if(maxOuter <=0) return;

// // // // //       let progress = outer.scrollTop / maxOuter;
// // // // //       progress = Math.min(Math.max(progress,0),1);

// // // // //       const maxLaptop = laptop.scrollHeight - laptop.clientHeight;
// // // // //       laptop.scrollTop = progress * maxLaptop;

// // // // //       const index = Math.round(progress * (FEATURES.length-1));
// // // // //       setActive(index);
// // // // //     };

// // // // //     outer.addEventListener("scroll",handleOuterScroll);
// // // // //     return ()=>outer.removeEventListener("scroll",handleOuterScroll);

// // // // //   },[]);

// // // // //   return(

// // // // // <section className="relative py-20 bg-[#FCFCFA] overflow-hidden">

// // // // // <style>{`
// // // // // .hide-scrollbar::-webkit-scrollbar{
// // // // // display:none;
// // // // // }
// // // // // .hide-scrollbar{
// // // // // -ms-overflow-style:none;
// // // // // scrollbar-width:none;
// // // // // }
// // // // // `}</style>

// // // // // {/* Background Lights */}

// // // // // <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[1500px] h-[750px] bg-indigo-300/20 blur-[220px] rounded-full"/>

// // // // // <div className="absolute bottom-0 right-0 w-[750px] h-[650px] bg-yellow-200/20 blur-[200px] rounded-full"/>

// // // // // <div className="absolute bottom-0 left-0 w-[650px] h-[550px] bg-blue-200/20 blur-[200px] rounded-full"/>


// // // // // <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 items-center gap-28">

// // // // // {/* LEFT SIDE */}

// // // // // <div>

// // // // // <h2 className="text-6xl font-semibold leading-tight text-gray-900 tracking-tight">
// // // // // We are not limited to just a Application!
// // // // // </h2>

// // // // // <p className="mt-6 text-lg text-gray-600 max-w-md leading-relaxed">
// // // // // Manage cases, schedules, and documents with precision.  
// // // // // Jurident simplifies every part of your practice with
// // // // // a seamless experience.
// // // // // </p>

// // // // // <div className="mt-14 space-y-7">

// // // // // {FEATURES.map((f,i)=>(
// // // // // <motion.div
// // // // // key={i}
// // // // // animate={{
// // // // // opacity:active===i?1:0.4,
// // // // // x:active===i?14:0
// // // // // }}
// // // // // transition={{ duration:0.35 }}
// // // // // className="flex items-center gap-4"
// // // // // >

// // // // // <div className={`w-3.5 h-3.5 rounded-full transition-all duration-300 ${
// // // // // active===i
// // // // // ? "bg-gradient-to-r from-yellow-400 to-orange-400 shadow-[0_0_12px_rgba(255,180,50,0.7)]"
// // // // // : "bg-gray-300"
// // // // // }`} />

// // // // // <p className={`text-lg transition-all duration-300 ${
// // // // // active===i
// // // // // ? "font-semibold text-black"
// // // // // : "text-gray-500"
// // // // // }`}>
// // // // // {f.title}
// // // // // </p>

// // // // // </motion.div>
// // // // // ))}

// // // // // </div>

// // // // // <motion.button
// // // // // whileHover={{ scale:1.06 }}
// // // // // whileTap={{ scale:0.97 }}
// // // // // className="mt-12 px-9 py-3 rounded-full bg-black text-white font-medium shadow-xl hover:shadow-2xl transition"
// // // // // >
// // // // // Get Started →
// // // // // </motion.button>

// // // // // </div>


// // // // // {/* RIGHT SIDE */}

// // // // // <div className="relative flex justify-center overflow-visible">

// // // // // {/* Rotating Halo */}

// // // // // <motion.div
// // // // // animate={{ rotate:360 }}
// // // // // transition={{ repeat:Infinity,duration:55,ease:"linear" }}
// // // // // className="absolute w-[780px] h-[780px] rounded-full bg-gradient-to-r from-indigo-200/30 via-blue-200/30 to-yellow-200/30 blur-[140px]"
// // // // // />

// // // // // {/* Scroll Trigger */}


// // // // // <div
// // // // // ref={outerScrollRef}
// // // // // className="relative h-[650px] w-[900px] -left-[100px] overflow-y-scroll hide-scrollbar"
// // // // // >
// // // // // <div className="h-[4000px]" />
// // // // // </div>

// // // // // {/* Laptop Container With Outline */}

// // // // // <div className="absolute inset-0 flex items-center justify-center pointer-events-none">

// // // // // <div className="relative outline outline-1 outline-gray-300/60 rounded-2xl p-6">

// // // // // <motion.div
// // // // // initial={{ scale:1 }}
// // // // // whileHover={{
// // // // // scale:1.12,
// // // // // rotateX:10,
// // // // // rotateY:-10,
// // // // // y:-25
// // // // // }}
// // // // // transition={{
// // // // // type:"spring",
// // // // // stiffness:200,
// // // // // damping:20
// // // // // }}
// // // // // style={{ perspective:1400 }}
// // // // // >

// // // // // <div className="relative">

// // // // // {/* Glow */}

// // // // // <div className="absolute -inset-24 bg-gradient-to-r from-indigo-400/20 via-blue-300/20 to-yellow-300/20 blur-[140px] rounded-full"/>

// // // // // <img
// // // // // src="/laptoptrans.png"
// // // // // className="relative w-[700px] max-w-none drop-shadow-[0_120px_200px_rgba(0,0,0,0.5)] hover:drop-shadow-[0_160px_260px_rgba(0,0,0,0.6)] transition-all duration-500"
// // // // // />

// // // // // {/* Laptop Screen */}

// // // // // <div
// // // // //   ref={laptopScrollRef}
// // // // //   className="absolute top-[27%] left-[17.5%] w-[65%] h-[43%] overflow-y-auto rounded-xl 
// // // // //   bg-black hide-scrollbar shadow-inner 
// // // // //   border border-white/15 ring-1 ring-black/40"
// // // // // >

// // // // // {FEATURES.map((f,i)=>(
// // // // // <img
// // // // // key={i}
// // // // // src={f.image}
// // // // // className="w-full h-full object-cover"
// // // // // />
// // // // // ))}

// // // // // </div>

// // // // // </div>

// // // // // </motion.div>

// // // // // </div>

// // // // // </div>


// // // // // {/* Progress Indicator */}

// // // // // <div className="absolute right-[-35px] top-1/2 -translate-y-1/2 h-[340px] w-[3px] bg-gray-200 rounded-full overflow-hidden">

// // // // // <motion.div
// // // // // className="w-full bg-gradient-to-b from-yellow-400 to-orange-400"
// // // // // style={{ height:progressHeight }}
// // // // // />

// // // // // </div>


// // // // // </div>

// // // // // </div>

// // // // // </section>
// // // // //   );
// // // // // }











// // // // import {
// // // //   motion,
// // // //   useScroll,
// // // //   useTransform,
// // // //   useSpring
// // // // } from "framer-motion";
// // // // import { useRef, useState, useEffect } from "react";

// // // // const FEATURES = [
// // // //   { title: "Dashboard", image: "/legal.png" },
// // // //   { title: "All Cases", image: "/casemanage.png" },
// // // //   { title: "Calendar", image: "/calander.png" },
// // // //   { title: "Export Cases", image: "/Home.png" },
// // // //   { title: "Expenses", image: "/expenses.png" }
// // // // ];

// // // // export default function Features() {

// // // //   const outerScrollRef = useRef(null);
// // // //   const laptopScrollRef = useRef(null);
// // // //   const [active,setActive] = useState(0);

// // // //   const { scrollYProgress } = useScroll({
// // // //     container:laptopScrollRef
// // // //   });

// // // //   const progressHeight = useSpring(
// // // //     useTransform(scrollYProgress,[0,1],["0%","100%"]),
// // // //     { stiffness:120,damping:30 }
// // // //   );

// // // //   useEffect(()=>{

// // // //     const outer = outerScrollRef.current;
// // // //     const laptop = laptopScrollRef.current;

// // // //     if(!outer || !laptop) return;

// // // //     const handleOuterScroll = () => {

// // // //       const maxOuter = outer.scrollHeight - outer.clientHeight;
// // // //       if(maxOuter <=0) return;

// // // //       let progress = outer.scrollTop / maxOuter;
// // // //       progress = Math.min(Math.max(progress,0),1);

// // // //       const maxLaptop = laptop.scrollHeight - laptop.clientHeight;
// // // //       laptop.scrollTop = progress * maxLaptop;

// // // //       const index = Math.round(progress * (FEATURES.length-1));
// // // //       setActive(index);
// // // //     };

// // // //     outer.addEventListener("scroll",handleOuterScroll);
// // // //     return ()=>outer.removeEventListener("scroll",handleOuterScroll);

// // // //   },[]);

// // // //   return(

// // // // <section className="relative py-20 bg-[#FAF9F6] overflow-hidden">

// // // // <style>{`
// // // // .hide-scrollbar::-webkit-scrollbar{
// // // // display:none;
// // // // }
// // // // .hide-scrollbar{
// // // // -ms-overflow-style:none;
// // // // scrollbar-width:none;
// // // // }
// // // // `}</style>

// // // // {/* Background Lights */}

// // // // <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[1500px] h-[750px] bg-indigo-300/20 blur-[220px] rounded-full"/>

// // // // <div className="absolute bottom-0 right-0 w-[750px] h-[650px] bg-yellow-200/20 blur-[200px] rounded-full"/>

// // // // <div className="absolute bottom-0 left-0 w-[650px] h-[550px] bg-blue-200/20 blur-[200px] rounded-full"/>


// // // // <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 items-center gap-28">

// // // // {/* LEFT SIDE */}

// // // // <div>

// // // // <h2 className="text-6xl font-semibold leading-tight text-gray-900 tracking-tight">
// // // // We are not limited to just a Application!
// // // // </h2>

// // // // <p className="mt-6 text-lg text-gray-600 max-w-md leading-relaxed">
// // // // Manage cases, schedules, and documents with precision.  
// // // // Jurident simplifies every part of your practice with
// // // // a seamless experience.
// // // // </p>

// // // // <div className="mt-14 space-y-7">

// // // // {FEATURES.map((f,i)=>(
// // // // <motion.div
// // // // key={i}
// // // // animate={{
// // // // opacity:active===i?1:0.4,
// // // // x:active===i?14:0
// // // // }}
// // // // transition={{ duration:0.35 }}
// // // // className="flex items-center gap-4"
// // // // >

// // // // <div className={`w-3.5 h-3.5 rounded-full transition-all duration-300 ${
// // // // active===i
// // // // ? "bg-gradient-to-r from-yellow-400 to-orange-400 shadow-[0_0_12px_rgba(255,180,50,0.7)]"
// // // // : "bg-gray-300"
// // // // }`} />

// // // // <p className={`text-lg transition-all duration-300 ${
// // // // active===i
// // // // ? "font-semibold text-black"
// // // // : "text-gray-500"
// // // // }`}>
// // // // {f.title}
// // // // </p>

// // // // </motion.div>
// // // // ))}

// // // // </div>

// // // // <motion.button
// // // // whileHover={{ scale:1.06 }}
// // // // whileTap={{ scale:0.97 }}
// // // // className="mt-12 px-9 py-3 rounded-full bg-black text-white font-medium shadow-xl hover:shadow-2xl transition"
// // // // >
// // // // Get Started →
// // // // </motion.button>

// // // // </div>


// // // // {/* RIGHT SIDE */}

// // // // <div className="relative flex justify-center overflow-visible">

// // // // {/* Rotating Halo */}

// // // // <motion.div
// // // // animate={{ rotate:360 }}
// // // // transition={{ repeat:Infinity,duration:55,ease:"linear" }}
// // // // className="absolute w-[780px] h-[780px] rounded-full bg-gradient-to-r from-indigo-200/30 via-blue-200/30 to-yellow-200/30 blur-[140px]"
// // // // />

// // // // {/* Scroll Trigger */}

// // // // <div
// // // // ref={outerScrollRef}
// // // // className="relative h-[650px] w-[900px] -left-[100px] overflow-y-scroll hide-scrollbar"
// // // // >
// // // // <div className="h-[4000px]" />
// // // // </div>

// // // // {/* Laptop Container With Outline */}

// // // // <div className="absolute inset-0 flex items-center justify-center pointer-events-none">

// // // // <div className="relative outline outline-1 outline-gray-300/60 rounded-2xl p-6">

// // // // <motion.div
// // // // initial={{ scale:1 }}
// // // // whileHover={{
// // // // scale:1.12,
// // // // rotateX:10,
// // // // rotateY:-10,
// // // // y:-25
// // // // }}
// // // // transition={{
// // // // type:"spring",
// // // // stiffness:200,
// // // // damping:20
// // // // }}
// // // // style={{ perspective:1400 }}
// // // // >

// // // // <div className="relative">

// // // // {/* Glow */}

// // // // <div className="absolute -inset-24 bg-gradient-to-r from-indigo-400/20 via-blue-300/20 to-yellow-300/20 blur-[140px] rounded-full"/>

// // // // <img
// // // // src="/laptoptrans.png"
// // // // className="relative w-[700px] max-w-none drop-shadow-[0_120px_200px_rgba(0,0,0,0.5)] hover:drop-shadow-[0_160px_260px_rgba(0,0,0,0.6)] transition-all duration-500"
// // // // />

// // // // {/* Laptop Screen */}

// // // // <div
// // // //   ref={laptopScrollRef}
// // // //   className="absolute top-[27%] left-[17.5%] w-[65%] h-[43%] overflow-y-auto rounded-xl 
// // // //   bg-black hide-scrollbar shadow-inner 
// // // //   border border-white/15 ring-1 ring-black/40"
// // // // >

// // // // {FEATURES.map((f,i)=>(
// // // // <img
// // // // key={i}
// // // // src={f.image}
// // // // className="w-full h-full object-cover"
// // // // />
// // // // ))}

// // // // </div>

// // // // </div>

// // // // </motion.div>

// // // // </div>

// // // // </div>


// // // // {/* Progress Indicator */}

// // // // <div className="absolute right-[-35px] top-1/2 -translate-y-1/2 h-[340px] w-[3px] bg-gray-200 rounded-full overflow-hidden">

// // // // <motion.div
// // // // className="w-full bg-gradient-to-b from-yellow-400 to-orange-400"
// // // // style={{ height:progressHeight }}
// // // // />

// // // // </div>


// // // // </div>

// // // // </div>

// // // // </section>
// // // //   );
// // // // }

















// // // import {
// // //   motion,
// // //   useScroll,
// // //   useTransform,
// // //   useSpring
// // // } from "framer-motion";
// // // import { useRef, useState, useEffect } from "react";

// // // const FEATURES = [
// // //   { title: "Dashboard", image: "/legal.png" },
// // //   { title: "All Cases", image: "/casemanage.png" },
// // //   { title: "Calendar", image: "/calander.png" },
// // //   { title: "Export Cases", image: "/Home.png" },
// // //   { title: "Expenses", image: "/expenses.png" }
// // // ];

// // // export default function Features() {

// // //   const outerScrollRef = useRef(null);
// // //   const laptopScrollRef = useRef(null);
// // //   const [active,setActive] = useState(0);

// // //   const { scrollYProgress } = useScroll({
// // //     container:laptopScrollRef
// // //   });

// // //   const progressHeight = useSpring(
// // //     useTransform(scrollYProgress,[0,1],["0%","100%"]),
// // //     { stiffness:120,damping:30 }
// // //   );

// // //   useEffect(()=>{

// // //     const outer = outerScrollRef.current;
// // //     const laptop = laptopScrollRef.current;

// // //     if(!outer || !laptop) return;

// // //     const handleOuterScroll = () => {

// // //       const maxOuter = outer.scrollHeight - outer.clientHeight;
// // //       if(maxOuter <=0) return;

// // //       let progress = outer.scrollTop / maxOuter;
// // //       progress = Math.min(Math.max(progress,0),1);

// // //       const maxLaptop = laptop.scrollHeight - laptop.clientHeight;
// // //       laptop.scrollTop = progress * maxLaptop;

// // //       const index = Math.round(progress * (FEATURES.length-1));
// // //       setActive(index);
// // //     };

// // //     outer.addEventListener("scroll",handleOuterScroll);
// // //     return ()=>outer.removeEventListener("scroll",handleOuterScroll);

// // //   },[]);

// // //   return(

// // // <section className="relative py-20 bg-[#FAF9F6] overflow-hidden">

// // // <style>{`
// // // .hide-scrollbar::-webkit-scrollbar{
// // // display:none;
// // // }
// // // .hide-scrollbar{
// // // -ms-overflow-style:none;
// // // scrollbar-width:none;
// // // }
// // // `}</style>

// // // <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 items-center gap-28">

// // // {/* LEFT SIDE */}

// // // <div>

// // // <h2 className="text-6xl font-semibold leading-tight text-gray-900 tracking-tight">
// // // We are not limited to just a Application!
// // // </h2>

// // // <p className="mt-6 text-lg text-gray-600 max-w-md leading-relaxed">
// // // Manage cases, schedules, and documents with precision.  
// // // Jurident simplifies every part of your practice with
// // // a seamless experience.
// // // </p>

// // // <div className="mt-14 space-y-7">

// // // {FEATURES.map((f,i)=>(
// // // <motion.div
// // // key={i}
// // // animate={{
// // // opacity:active===i?1:0.4,
// // // x:active===i?14:0
// // // }}
// // // transition={{ duration:0.35 }}
// // // className="flex items-center gap-4"
// // // >

// // // <div className={`w-3.5 h-3.5 rounded-full transition-all duration-300 ${
// // // active===i
// // // ? "bg-gradient-to-r from-yellow-400 to-orange-400 shadow-[0_0_12px_rgba(255,180,50,0.7)]"
// // // : "bg-gray-300"
// // // }`} />

// // // <p className={`text-lg transition-all duration-300 ${
// // // active===i
// // // ? "font-semibold text-black"
// // // : "text-gray-500"
// // // }`}>
// // // {f.title}
// // // </p>

// // // </motion.div>
// // // ))}

// // // </div>

// // // <motion.button
// // // whileHover={{ scale:1.06 }}
// // // whileTap={{ scale:0.97 }}
// // // className="mt-12 px-9 py-3 rounded-full bg-black text-white font-medium shadow-xl hover:shadow-2xl transition"
// // // >
// // // Get Started →
// // // </motion.button>

// // // </div>


// // // {/* RIGHT SIDE */}

// // // <div className="relative flex justify-center overflow-visible">

// // // <motion.div
// // // animate={{ rotate:360 }}
// // // transition={{ repeat:Infinity,duration:55,ease:"linear" }}
// // // className="absolute w-[780px] h-[780px] rounded-full bg-gradient-to-r from-indigo-200/30 via-blue-200/30 to-yellow-200/30 blur-[140px]"
// // // />

// // // <div
// // // ref={outerScrollRef}
// // // className="relative h-[650px] w-[900px] -left-[100px] overflow-y-scroll hide-scrollbar"
// // // >
// // // <div className="h-[4000px]" />
// // // </div>

// // // <div className="absolute inset-0 flex items-center justify-center pointer-events-none">

// // // <div className="relative outline outline-1 outline-gray-300/60 rounded-2xl p-6">

// // // <motion.div
// // // initial={{ scale:1 }}
// // // whileHover={{
// // // scale:1.12,
// // // rotateX:10,
// // // rotateY:-10,
// // // y:-25
// // // }}
// // // transition={{
// // // type:"spring",
// // // stiffness:200,
// // // damping:20
// // // }}
// // // style={{ perspective:1400 }}
// // // >

// // // <div className="relative">

// // // <div className="absolute -inset-24 bg-gradient-to-r from-indigo-400/20 via-blue-300/20 to-yellow-300/20 blur-[140px] rounded-full"/>

// // // <img
// // // src="/laptoptrans.png"
// // // className="relative w-[700px] max-w-none drop-shadow-[0_120px_200px_rgba(0,0,0,0.5)] hover:drop-shadow-[0_160px_260px_rgba(0,0,0,0.6)] transition-all duration-500"
// // // />

// // // <div
// // //   ref={laptopScrollRef}
// // //   className="absolute top-[27%] left-[17.5%] w-[65%] h-[43%] overflow-y-auto rounded-xl 
// // //   bg-black hide-scrollbar shadow-inner 
// // //   border border-white/15 ring-1 ring-black/40"
// // // >

// // // {FEATURES.map((f,i)=>(
// // // <img
// // // key={i}
// // // src={f.image}
// // // className="w-full h-full object-cover"
// // // />
// // // ))}

// // // </div>

// // // </div>

// // // </motion.div>

// // // </div>

// // // </div>

// // // <div className="absolute right-[-35px] top-1/2 -translate-y-1/2 h-[340px] w-[3px] bg-gray-200 rounded-full overflow-hidden">

// // // <motion.div
// // // className="w-full bg-gradient-to-b from-yellow-400 to-orange-400"
// // // style={{ height:progressHeight }}
// // // />

// // // </div>

// // // </div>

// // // </div>

// // // </section>
// // //   );
// // // }















// // ////final code 
// // // import {
// // //   motion,
// // //   useScroll,
// // //   useTransform,
// // //   useSpring
// // // } from "framer-motion";
// // // import { useRef, useState, useEffect } from "react";

// // // const FEATURES = [
// // //   { title: "Dashboard", image: "/legal.png" },
// // //   { title: "All Cases", image: "/casemanage.png" },
// // //   { title: "Calendar", image: "/calander.png" },
// // //   { title: "Export Cases", image: "/Home.png" },
// // //   { title: "Expenses", image: "/expenses.png" }
// // // ];

// // // export default function Features() {

// // //   const outerScrollRef = useRef(null);
// // //   const laptopScrollRef = useRef(null);
// // //   const [active,setActive] = useState(0);

// // //   const { scrollYProgress } = useScroll({
// // //     container:laptopScrollRef
// // //   });

// // //   const progressHeight = useSpring(
// // //     useTransform(scrollYProgress,[0,1],["0%","100%"]),
// // //     { stiffness:120,damping:30 }
// // //   );

// // //   useEffect(()=>{

// // //     const outer = outerScrollRef.current;
// // //     const laptop = laptopScrollRef.current;

// // //     if(!outer || !laptop) return;

// // //     const handleOuterScroll = () => {

// // //       const maxOuter = outer.scrollHeight - outer.clientHeight;
// // //       if(maxOuter <=0) return;

// // //       let progress = outer.scrollTop / maxOuter;
// // //       progress = Math.min(Math.max(progress,0),1);

// // //       const maxLaptop = laptop.scrollHeight - laptop.clientHeight;
// // //       laptop.scrollTop = progress * maxLaptop;

// // //       const index = Math.round(progress * (FEATURES.length-1));
// // //       setActive(index);
// // //     };

// // //     outer.addEventListener("scroll",handleOuterScroll);
// // //     return ()=>outer.removeEventListener("scroll",handleOuterScroll);

// // //   },[]);

// // //   return(

// // // <section className="relative pt-24 py-20 bg-[#FAF9F6] overflow-hidden">

// // // <style>{`
// // // .hide-scrollbar::-webkit-scrollbar{
// // // display:none;
// // // }
// // // .hide-scrollbar{
// // // -ms-overflow-style:none;
// // // scrollbar-width:none;
// // // }
// // // `}</style>

// // // <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 items-center gap-28">

// // // {/* LEFT SIDE */}

// // // <div>

// // // <h3 className="text-6xl font-semibold leading-tight text-gray-1000 tracking-tight">
// // // The Smartest Way
// // // to Manage Your
// // // Legal Practice.
// // // </h3>

// // // <p className="pb-0 mt-6 text-lg text-gray-600 max-w-md leading-relaxed">
// // // Expand your reach, streamline your workflow, and get paid faster all in one smart legal tech suite.
// // // </p>

// // // <div className="mt-14 space-y-7">

// // // {FEATURES.map((f,i)=>(
// // // <motion.div
// // // key={i}
// // // animate={{
// // // opacity:active===i?1:0.4,
// // // x:active===i?14:0
// // // }}
// // // transition={{ duration:0.35 }}
// // // className="flex items-center gap-4"
// // // >

// // // <div className={`w-3.5 h-3.5 rounded-full transition-all duration-300 ${
// // // active===i
// // // ? "bg-gradient-to-r from-yellow-400 to-orange-400 shadow-[0_0_12px_rgba(255,180,50,0.7)]"
// // // : "bg-gray-300"
// // // }`} />

// // // <p className={`text-lg transition-all duration-300 ${
// // // active===i
// // // ? "font-semibold text-black"
// // // : "text-gray-800"
// // // }`}>
// // // {f.title}
// // // </p>

// // // </motion.div>
// // // ))}

// // // </div>

// // // <motion.button
// // // whileHover={{ scale:1.06 }}
// // // whileTap={{ scale:0.97 }}
// // // className="mt-12 px-9 py-3 rounded-full bg-black text-white font-medium shadow-xl hover:shadow-2xl transition"
// // // >
// // // Get Started →
// // // </motion.button>

// // // </div>


// // // {/* RIGHT SIDE */}

// // // <div className="relative flex justify-center overflow-visible">

// // // <div
// // // ref={outerScrollRef}
// // // className="relative h-[650px] w-[900px] -left-[100px] overflow-y-scroll hide-scrollbar"
// // // >
// // // <div className="h-[4000px]" />
// // // </div>

// // // {/* Laptop Container */}

// // // <div className="absolute inset-0 flex items-center justify-center pointer-events-none">

// // // <div className="relative outline outline-1 outline-gray-400/60 rounded-2xl p-6">

// // // <motion.div
// // // initial={{ scale:1 }}
// // // whileHover={{
// // // scale:1.12,
// // // rotateX:10,
// // // rotateY:-10,
// // // y:-25
// // // }}
// // // transition={{
// // // type:"spring",
// // // stiffness:200,
// // // damping:20
// // // }}
// // // style={{ perspective:1400 }}
// // // >

// // // <div className="relative">

// // // <img
// // // src="/laptoptrans.png"
// // // className="relative w-[650px] max-w-none drop-shadow-[0_60px_120px_rgba(0,0,0,0.45)] hover:drop-shadow-[0_80px_160px_rgba(0,0,0,0.55)] transition-all duration-500"
// // // />

// // // {/* Laptop Screen */}

// // // <div
// // //   ref={laptopScrollRef}
// // //   className="absolute top-[27%] left-[17.5%] w-[65%] h-[43%] overflow-y-auto rounded-xl 
// // //   bg-black hide-scrollbar shadow-inner 
// // //   border border-white/15 ring-1 ring-black/40"
// // // >

// // // {FEATURES.map((f,i)=>(
// // // <img
// // // key={i}
// // // src={f.image}
// // // className="w-full h-full object-cover"
// // // />
// // // ))}

// // // </div>

// // // </div>

// // // </motion.div>

// // // </div>

// // // </div>

// // // {/* Progress Indicator */}
// // // {/* 
// // // <div className="absolute right-[-35px] top-1/2 -translate-y-1/2 h-[340px] w-[3px] bg-gray-200 rounded-full overflow-hidden">

// // // <motion.div
// // // className="w-full bg-gradient-to-b from-yellow-400 to-orange-400"
// // // style={{ height:progressHeight }}
// // // /> */}

// // // <div className="absolute right-[-35px] top-1/2 -translate-y-1/2 h-[340px] w-[3px] bg-gray-200 rounded-full overflow-hidden">

// // // <motion.div
// // // className="w-full bg-black"
// // // style={{ height:progressHeight }}
// // // />

// // // </div>

// // // </div>

// // // </div>


// // // </section>
// // //   );
// // // }














// // import {
// // motion,
// // useScroll,
// // useTransform,
// // useSpring
// // } from "framer-motion";
// // import { useRef, useState, useEffect } from "react";

// // const FEATURES = [
// // { title: "Dashboard", image: "/legal.png" },
// // { title: "All Cases", image: "/casemanage.png" },
// // { title: "Calendar", image: "/calander.png" },
// // { title: "Export Cases", image: "/Home.png" },
// // { title: "Expenses", image: "/expenses.png" }
// // ];

// // export default function Features() {

// // const outerScrollRef = useRef(null);
// // const laptopScrollRef = useRef(null);
// // const [active,setActive] = useState(0);

// // const { scrollYProgress } = useScroll({
// // container: laptopScrollRef
// // });

// // const progressHeight = useSpring(
// // useTransform(scrollYProgress,[0,1],["0%","100%"]),
// // { stiffness:120,damping:30 }
// // );

// // useEffect(()=>{

// // ```
// // const outer = outerScrollRef.current;
// // const laptop = laptopScrollRef.current;

// // if(!outer || !laptop) return;

// // const handleOuterScroll = () => {

// //   const maxOuter = outer.scrollHeight - outer.clientHeight;
// //   if(maxOuter <=0) return;

// //   let progress = outer.scrollTop / maxOuter;
// //   progress = Math.min(Math.max(progress,0),1);

// //   const maxLaptop = laptop.scrollHeight - laptop.clientHeight;
// //   laptop.scrollTop = progress * maxLaptop;

// //   const index = Math.round(progress * (FEATURES.length-1));
// //   setActive(index);
// // };

// // outer.addEventListener("scroll",handleOuterScroll);

// // return () => {
// //   if (outer) {
// //     outer.removeEventListener("scroll",handleOuterScroll);
// //   }
// // };
// // ```

// // },[]);

// // return(

// // <section className="relative pt-24 py-20 bg-[#FAF9F6] overflow-hidden">

// // <style>{`
// // .hide-scrollbar::-webkit-scrollbar{
// // display:none;
// // }
// // .hide-scrollbar{
// // -ms-overflow-style:none;
// // scrollbar-width:none;
// // }
// // `}</style>

// // <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 items-center gap-28">

// // {/* LEFT SIDE */}

// // <div className="max-w-md">

// // <h3 className="text-5xl font-semibold leading-tight text-gray-1000 tracking-tight">
// // The Smartest Way
// // to Manage Your
// // Legal Practice.
// // </h3>

// // <p className="mt-5 text-base text-gray-600 leading-relaxed">
// // Expand your reach, streamline your workflow, and get paid faster all in one smart legal tech suite.
// // </p>

// // <div className="mt-10 space-y-5">

// // {FEATURES.map((f,i)=>(
// // <motion.div
// // key={i}
// // animate={{
// // opacity:active===i?1:0.4,
// // x:active===i?14:0
// // }}
// // transition={{ duration:0.35 }}
// // className="flex items-center gap-3"

// // >

// // <div className={`w-3 h-3 rounded-full transition-all duration-300 ${
// // active===i
// // ? "bg-gradient-to-r from-yellow-400 to-orange-400 shadow-[0_0_10px_rgba(255,180,50,0.7)]"
// // : "bg-gray-300"
// // }`} />

// // <p className={`text-base transition-all duration-300 ${
// // active===i
// // ? "font-semibold text-black"
// // : "text-gray-800"
// // }`}>
// // {f.title}
// // </p>

// // </motion.div>
// // ))}

// // </div>

// // <motion.button
// // whileHover={{ scale:1.06 }}
// // whileTap={{ scale:0.97 }}
// // className="mt-10 px-8 py-2.5 rounded-full bg-black text-white text-sm font-medium shadow-xl hover:shadow-2xl transition"

// // >

// // Get Started →
// // </motion.button>

// // </div>

// // {/* RIGHT SIDE */}

// // <div className="relative flex justify-center overflow-visible">

// // <div
// // ref={outerScrollRef}
// // className="relative h-[650px] w-[900px] -left-[100px] overflow-y-scroll hide-scrollbar"
// // >
// // <div className="h-[4000px]" />
// // </div>

// // {/* Laptop Container */}

// // <div className="absolute inset-0 flex items-center justify-center pointer-events-none">

// // <div className="relative outline outline-1 outline-gray-400/60 rounded-2xl p-6">

// // <motion.div
// // initial={{ scale:1 }}
// // whileHover={{
// // scale:1.12,
// // rotateX:10,
// // rotateY:-10,
// // y:-25
// // }}
// // transition={{
// // type:"spring",
// // stiffness:200,
// // damping:20
// // }}
// // style={{ perspective:1400 }}

// // >

// // <div className="relative">

// // <img
// // src="/laptoptrans.png"
// // className="relative w-[650px] max-w-none drop-shadow-[0_60px_120px_rgba(0,0,0,0.45)] hover:drop-shadow-[0_80px_160px_rgba(0,0,0,0.55)] transition-all duration-500"
// // />

// // <div
// // ref={laptopScrollRef}
// // className="absolute top-[27%] left-[17.5%] w-[65%] h-[43%] overflow-y-auto rounded-xl 
// // bg-black hide-scrollbar shadow-inner 
// // border border-white/15 ring-1 ring-black/40"
// // >

// // {FEATURES.map((f,i)=>( <img
// // key={i}
// // src={f.image}
// // className="w-full h-full object-cover"
// // />
// // ))}

// // </div>

// // </div>

// // </motion.div>

// // </div>

// // </div>

// // <div className="absolute right-[-35px] top-1/2 -translate-y-1/2 h-[340px] w-[3px] bg-gray-200 rounded-full overflow-hidden">

// // <motion.div
// // className="w-full bg-black"
// // style={{ height:progressHeight }}
// // />

// // </div>

// // </div>

// // </div>

// // </section>
// //   );
// // }





































// // ////design 2
// // import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// // import { useRef, useState, useEffect } from "react";

// // const FEATURES = [
// //   { title: "Dashboard", image: "/legal.png" },
// //   { title: "All Cases", image: "/casemanage.png" },
// //   { title: "Calendar", image: "/calander.png" },
// //   { title: "Export Cases", image: "/Home.png" },
// //   { title: "Expenses", image: "/expenses.png" }
// // ];

// // export default function Features() {

// //   const outerScrollRef = useRef(null);
// //   const laptopScrollRef = useRef(null);
// //   const [active, setActive] = useState(0);

// //   const { scrollYProgress } = useScroll({
// //     container: laptopScrollRef
// //   });

// //   const progressHeight = useSpring(
// //     useTransform(scrollYProgress, [0, 1], ["0%", "100%"]),
// //     { stiffness: 120, damping: 30 }
// //   );

// //   useEffect(() => {

// //     const outer = outerScrollRef.current;
// //     const laptop = laptopScrollRef.current;

// //     if (!outer || !laptop) return;

// //     const handleOuterScroll = () => {

// //       const maxOuter = outer.scrollHeight - outer.clientHeight;
// //       if (maxOuter <= 0) return;

// //       let progress = outer.scrollTop / maxOuter;
// //       progress = Math.min(Math.max(progress, 0), 1);

// //       const maxLaptop = laptop.scrollHeight - laptop.clientHeight;
// //       laptop.scrollTop = progress * maxLaptop;

// //       const index = Math.round(progress * (FEATURES.length - 1));
// //       setActive(index);
// //     };

// //     outer.addEventListener("scroll", handleOuterScroll);

// //     return () => {
// //       outer.removeEventListener("scroll", handleOuterScroll);
// //     };

// //   }, []);

// //   return (
// //     <section className="relative pt-28 pb-24 bg-gradient-to-b from-[#FAF9F6] via-[#faf9f6] to-[#f3f3f3] overflow-hidden">

// //       <style>{`
// //         .hide-scrollbar::-webkit-scrollbar{
// //           display:none;
// //         }
// //         .hide-scrollbar{
// //           -ms-overflow-style:none;
// //           scrollbar-width:none;
// //         }
// //       `}</style>

// //       <div className="relative max-w-7xl mx-auto px-6 grid lg:grid-cols-2 items-center gap-32">

// //         {/* LEFT SIDE */}

// //         <div className="max-w-md">

// //           <h3 className="text-5xl font-semibold leading-tight tracking-tight text-black">
// //             The Smartest Way to Manage Your Legal Practice.
// //           </h3>

// //           <p className="mt-6 text-gray-600 text-lg leading-relaxed">
// //             Expand your reach, streamline your workflow, and get paid faster
// //             with one powerful legal technology platform designed for modern firms.
// //           </p>

// //           <div className="mt-12 space-y-6">

// //             {FEATURES.map((f, i) => (
// //               <motion.div
// //                 key={i}
// //                 animate={{
// //                   opacity: active === i ? 1 : 0.35,
// //                   x: active === i ? 16 : 0
// //                 }}
// //                 transition={{ duration: 0.35 }}
// //                 className="flex items-center gap-4 group"
// //               >

// //                 <div
// //                   className={`w-3 h-3 rounded-full transition-all duration-300 ${
// //                     active === i
// //                       ? "bg-gradient-to-r from-yellow-400 to-orange-400 shadow-[0_0_12px_rgba(255,180,50,0.8)]"
// //                       : "bg-gray-300"
// //                   }`}
// //                 />

// //                 <p
// //                   className={`text-base transition-all duration-300 ${
// //                     active === i
// //                       ? "font-semibold text-black"
// //                       : "text-gray-500"
// //                   }`}
// //                 >
// //                   {f.title}
// //                 </p>

// //               </motion.div>
// //             ))}

// //           </div>

// //           <motion.button
// //             whileHover={{ scale: 1.05 }}
// //             whileTap={{ scale: 0.96 }}
// //             className="mt-12 px-8 py-3 rounded-full bg-black text-white text-sm font-medium shadow-lg hover:shadow-2xl transition-all"
// //           >
// //             Get Started →
// //           </motion.button>

// //         </div>


// //         {/* RIGHT SIDE */}

// //         <div className="relative flex justify-center overflow-visible">

// //           <div
// //             ref={outerScrollRef}
// //             className="relative h-[650px] w-[900px] -left-[100px] overflow-y-scroll hide-scrollbar"
// //           >
// //             <div className="h-[4000px]" />
// //           </div>


// //           {/* Laptop Container */}

// //           <div className="absolute inset-0 flex items-center justify-center pointer-events-none">

// //             <div className="relative backdrop-blur-md bg-white/40 border border-white/40 shadow-[0_40px_120px_rgba(0,0,0,0.15)] rounded-3xl p-8">

// //               <motion.div
// //                 initial={{ scale: 1 }}
// //                 whileHover={{
// //                   scale: 1.12,
// //                   rotateX: 10,
// //                   rotateY: -10,
// //                   y: -28
// //                 }}
// //                 transition={{
// //                   type: "spring",
// //                   stiffness: 200,
// //                   damping: 22
// //                 }}
// //                 style={{ perspective: 1400 }}
// //               >

// //                 <div className="relative">

// //                   <img
// //                     src="/laptoptrans.png"
// //                     className="relative w-[650px] max-w-none drop-shadow-[0_70px_140px_rgba(0,0,0,0.45)] transition-all duration-500"
// //                   />

// //                   <div
// //                     ref={laptopScrollRef}
// //                     className="absolute top-[27%] left-[17.5%] w-[65%] h-[43%] overflow-y-auto rounded-xl bg-black hide-scrollbar shadow-inner border border-white/10"
// //                   >

// //                     {FEATURES.map((f, i) => (
// //                       <img
// //                         key={i}
// //                         src={f.image}
// //                         className="w-full h-full object-cover"
// //                       />
// //                     ))}

// //                   </div>

// //                 </div>

// //               </motion.div>

// //             </div>

// //           </div>


// //           {/* Progress bar */}

// //           <div className="absolute right-[-40px] top-1/2 -translate-y-1/2 h-[360px] w-[3px] bg-gray-200 rounded-full overflow-hidden shadow-inner">

// //             <motion.div
// //               className="w-full bg-black"
// //               style={{ height: progressHeight }}
// //             />

// //           </div>

// //         </div>

// //       </div>

// //     </section>
// //   );
// // }





















// // //3rd 
// // import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// // import { useRef, useState, useEffect } from "react";

// // const FEATURES = [
// //   { title: "Dashboard", image: "/legal.png" },
// //   { title: "All Cases", image: "/casemanage.png" },
// //   { title: "Calendar", image: "/calander.png" },
// //   { title: "Export Cases", image: "/Home.png" },
// //   { title: "Expenses", image: "/expenses.png" }
// // ];

// // export default function Features() {

// //   const outerScrollRef = useRef(null);
// //   const laptopScrollRef = useRef(null);
// //   const [active, setActive] = useState(0);

// //   const { scrollYProgress } = useScroll({
// //     container: laptopScrollRef
// //   });

// //   const progressHeight = useSpring(
// //     useTransform(scrollYProgress, [0, 1], ["0%", "100%"]),
// //     { stiffness: 120, damping: 30 }
// //   );

// //   useEffect(() => {

// //     const outer = outerScrollRef.current;
// //     const laptop = laptopScrollRef.current;

// //     if (!outer || !laptop) return;

// //     const handleOuterScroll = () => {

// //       const maxOuter = outer.scrollHeight - outer.clientHeight;
// //       if (maxOuter <= 0) return;

// //       let progress = outer.scrollTop / maxOuter;
// //       progress = Math.min(Math.max(progress, 0), 1);

// //       const maxLaptop = laptop.scrollHeight - laptop.clientHeight;
// //       laptop.scrollTop = progress * maxLaptop;

// //       const index = Math.round(progress * (FEATURES.length - 1));
// //       setActive(index);
// //     };

// //     outer.addEventListener("scroll", handleOuterScroll);

// //     return () => {
// //       outer.removeEventListener("scroll", handleOuterScroll);
// //     };

// //   }, []);

// //   return (
// //     <section className="relative pt-32 pb-28 bg-[#FAF9F6] overflow-hidden">

// //       {/* Background Glow */}
// //       <div className="absolute top-40 right-0 w-[600px] h-[600px] bg-yellow-200/30 blur-[160px] rounded-full"/>
// //       <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-orange-200/30 blur-[140px] rounded-full"/>

// //       <style>{`
// //         .hide-scrollbar::-webkit-scrollbar{
// //           display:none;
// //         }
// //         .hide-scrollbar{
// //           -ms-overflow-style:none;
// //           scrollbar-width:none;
// //         }
// //       `}</style>

// //       <div className="relative max-w-7xl mx-auto px-6 grid lg:grid-cols-2 items-center gap-32">

// //         {/* LEFT */}

// //         <div className="max-w-md">

// //           <h3 className="text-[52px] font-semibold leading-[1.1] tracking-tight">
// //             The Smartest Way to Manage Your Legal Practice
// //           </h3>

// //           <p className="mt-6 text-gray-600 text-lg leading-relaxed">
// //             Expand your reach, streamline workflows, and manage cases effortlessly with a powerful legal platform designed for modern firms.
// //           </p>

// //           <div className="mt-12 space-y-5">

// //             {FEATURES.map((f, i) => (
// //               <motion.div
// //                 key={i}
// //                 animate={{
// //                   opacity: active === i ? 1 : 0.35,
// //                   x: active === i ? 18 : 0
// //                 }}
// //                 transition={{ duration: 0.35 }}
// //                 className={`flex items-center gap-4 px-5 py-4 rounded-xl transition-all duration-300
// //                 ${active === i
// //                   ? "bg-white shadow-lg"
// //                   : "bg-transparent"
// //                 }`}
// //               >

// //                 <div
// //                   className={`w-3 h-3 rounded-full ${
// //                     active === i
// //                       ? "bg-gradient-to-r from-yellow-400 to-orange-400 shadow-[0_0_10px_rgba(255,180,50,0.8)]"
// //                       : "bg-gray-300"
// //                   }`}
// //                 />

// //                 <p
// //                   className={`text-base ${
// //                     active === i
// //                       ? "font-semibold text-black"
// //                       : "text-gray-600"
// //                   }`}
// //                 >
// //                   {f.title}
// //                 </p>

// //               </motion.div>
// //             ))}

// //           </div>

// //           <motion.button
// //             whileHover={{ scale: 1.05 }}
// //             whileTap={{ scale: 0.96 }}
// //             className="mt-12 px-9 py-3 rounded-full bg-black text-white text-sm font-medium shadow-xl hover:shadow-2xl transition"
// //           >
// //             Get Started →
// //           </motion.button>

// //         </div>


// //         {/* RIGHT */}

// //         <div className="relative flex justify-center">

// //           <div
// //             ref={outerScrollRef}
// //             className="relative h-[650px] w-[900px] -left-[100px] overflow-y-scroll hide-scrollbar"
// //           >
// //             <div className="h-[4000px]" />
// //           </div>


// //           {/* Laptop */}

// //           <div className="absolute inset-0 flex items-center justify-center pointer-events-none">

// //             <div className="relative rounded-3xl bg-white/40 backdrop-blur-lg border border-white/40 p-8 shadow-[0_50px_140px_rgba(0,0,0,0.15)]">

// //               <motion.div
// //                 whileHover={{
// //                   scale: 1.12,
// //                   rotateX: 12,
// //                   rotateY: -12,
// //                   y: -30
// //                 }}
// //                 transition={{
// //                   type: "spring",
// //                   stiffness: 200,
// //                   damping: 20
// //                 }}
// //                 style={{ perspective: 1400 }}
// //               >

// //                 <div className="relative">

// //                   <img
// //                     src="/laptoptrans.png"
// //                     className="w-[650px] drop-shadow-[0_80px_160px_rgba(0,0,0,0.5)]"
// //                   />

// //                   <div
// //                     ref={laptopScrollRef}
// //                     className="absolute top-[27%] left-[17.5%] w-[65%] h-[43%] overflow-y-auto rounded-xl bg-black hide-scrollbar shadow-inner border border-white/10"
// //                   >

// //                     {FEATURES.map((f, i) => (
// //                       <img
// //                         key={i}
// //                         src={f.image}
// //                         className="w-full h-full object-cover"
// //                       />
// //                     ))}

// //                   </div>

// //                 </div>

// //               </motion.div>

// //             </div>

// //           </div>


// //           {/* Progress */}

// //           <div className="absolute right-[-40px] top-1/2 -translate-y-1/2 h-[360px] w-[4px] bg-gray-200 rounded-full overflow-hidden">

// //             <motion.div
// //               className="w-full bg-black"
// //               style={{ height: progressHeight }}
// //             />

// //           </div>

// //         </div>

// //       </div>

// //     </section>
// //   );
// // }







// // //4th
// // import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// // import { useRef, useState, useEffect } from "react";

// // const FEATURES = [
// //   { title: "Dashboard", image: "/legal.png" },
// //   { title: "All Cases", image: "/casemanage.png" },
// //   { title: "Calendar", image: "/calander.png" },
// //   { title: "Export Cases", image: "/Home.png" },
// //   { title: "Expenses", image: "/expenses.png" }
// // ];

// // export default function Features() {

// //   const outerScrollRef = useRef(null);
// //   const laptopScrollRef = useRef(null);
// //   const [active, setActive] = useState(0);

// //   const { scrollYProgress } = useScroll({
// //     container: laptopScrollRef
// //   });

// //   const progressHeight = useSpring(
// //     useTransform(scrollYProgress, [0, 1], ["0%", "100%"]),
// //     { stiffness: 120, damping: 30 }
// //   );

// //   useEffect(() => {

// //     const outer = outerScrollRef.current;
// //     const laptop = laptopScrollRef.current;

// //     if (!outer || !laptop) return;

// //     const handleOuterScroll = () => {

// //       const maxOuter = outer.scrollHeight - outer.clientHeight;
// //       if (maxOuter <= 0) return;

// //       let progress = outer.scrollTop / maxOuter;
// //       progress = Math.min(Math.max(progress, 0), 1);

// //       const maxLaptop = laptop.scrollHeight - laptop.clientHeight;
// //       laptop.scrollTop = progress * maxLaptop;

// //       const index = Math.round(progress * (FEATURES.length - 1));
// //       setActive(index);
// //     };

// //     outer.addEventListener("scroll", handleOuterScroll);

// //     return () => {
// //       outer.removeEventListener("scroll", handleOuterScroll);
// //     };

// //   }, []);

// //   return (
// //     <section className="relative py-24 bg-[#FAF9F6] overflow-hidden">

// //       <style>{`
// //         .hide-scrollbar::-webkit-scrollbar{
// //           display:none;
// //         }
// //         .hide-scrollbar{
// //           -ms-overflow-style:none;
// //           scrollbar-width:none;
// //         }
// //       `}</style>

// //       <div className="max-w-6xl mx-auto px-6">

// //         {/* Heading */}

// //         <div className="text-center max-w-2xl mx-auto mb-16">

// //           <h2 className="text-4xl font-semibold leading-tight">
// //             Manage Your Legal Practice
// //             <span className="block text-gray-600 text-2xl mt-2">
// //               Faster, Smarter, Better
// //             </span>
// //           </h2>

// //           <p className="text-gray-600 mt-5">
// //             Powerful tools to manage cases, track expenses,
// //             organize schedules and streamline your workflow.
// //           </p>

// //         </div>

// //         {/* Content */}

// //         <div className="grid lg:grid-cols-[1fr_520px_1fr] items-center gap-10">

// //           {/* Left Features */}

// //           <div className="space-y-6">

// //             {FEATURES.slice(0,3).map((f, i) => (
// //               <motion.div
// //                 key={i}
// //                 animate={{
// //                   opacity: active === i ? 1 : 0.4,
// //                   x: active === i ? 10 : 0
// //                 }}
// //                 className="flex items-center gap-3"
// //               >

// //                 <div className={`w-3 h-3 rounded-full ${
// //                   active === i
// //                   ? "bg-gradient-to-r from-yellow-400 to-orange-400"
// //                   : "bg-gray-300"
// //                 }`} />

// //                 <p className={`${
// //                   active === i
// //                   ? "font-semibold text-black"
// //                   : "text-gray-500"
// //                 }`}>
// //                   {f.title}
// //                 </p>

// //               </motion.div>
// //             ))}

// //           </div>


// //           {/* Laptop */}

// //           <div className="relative flex justify-center">

// //             <div
// //               ref={outerScrollRef}
// //               className="absolute h-[500px] w-[500px] overflow-y-scroll hide-scrollbar"
// //             >
// //               <div className="h-[3500px]" />
// //             </div>

// //             <motion.div
// //               whileHover={{
// //                 scale: 1.05,
// //                 rotateX: 6,
// //                 rotateY: -6
// //               }}
// //               transition={{ type: "spring", stiffness: 200 }}
// //               className="relative"
// //               style={{ perspective: 1200 }}
// //             >

// //               <img
// //                 src="/laptoptrans.png"
// //                 className="w-[520px] drop-shadow-[0_40px_90px_rgba(0,0,0,0.4)]"
// //               />

// //               <div
// //                 ref={laptopScrollRef}
// //                 className="absolute top-[27%] left-[17.5%] w-[65%] h-[43%] overflow-y-auto rounded-xl bg-black hide-scrollbar"
// //               >

// //                 {FEATURES.map((f, i) => (
// //                   <img
// //                     key={i}
// //                     src={f.image}
// //                     className="w-full h-full object-cover"
// //                   />
// //                 ))}

// //               </div>

// //             </motion.div>

// //           </div>


// //           {/* Right Features */}

// //           <div className="space-y-6">

// //             {FEATURES.slice(3).map((f, i) => (
// //               <motion.div
// //                 key={i}
// //                 animate={{
// //                   opacity: active === i+3 ? 1 : 0.4,
// //                   x: active === i+3 ? -10 : 0
// //                 }}
// //                 className="flex items-center gap-3 justify-start"
// //               >

// //                 <div className={`w-3 h-3 rounded-full ${
// //                   active === i+3
// //                   ? "bg-gradient-to-r from-yellow-400 to-orange-400"
// //                   : "bg-gray-300"
// //                 }`} />

// //                 <p className={`${
// //                   active === i+3
// //                   ? "font-semibold text-black"
// //                   : "text-gray-500"
// //                 }`}>
// //                   {f.title}
// //                 </p>

// //               </motion.div>
// //             ))}

// //           </div>

// //         </div>

// //         {/* Progress Indicator */}

// //         <div className="flex justify-center mt-12">

// //           <div className="h-[4px] w-[220px] bg-gray-200 rounded-full overflow-hidden">

// //             <motion.div
// //               className="h-full bg-black"
// //               style={{ width: progressHeight }}
// //             />

// //           </div>

// //         </div>

// //       </div>

// //     </section>
// //   );
// // }
















// // //5th
// // import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// // import { useRef, useState, useEffect } from "react";

// // const FEATURES = [
// //   { title: "Dashboard", image: "/legal.png" },
// //   { title: "All Cases", image: "/casemanage.png" },
// //   { title: "Calendar", image: "/calander.png" },
// //   { title: "Export Cases", image: "/Home.png" },
// //   { title: "Expenses", image: "/expenses.png" }
// // ];

// // export default function Features() {

// //   const outerScrollRef = useRef(null);
// //   const laptopScrollRef = useRef(null);
// //   const [active, setActive] = useState(0);

// //   const { scrollYProgress } = useScroll({
// //     container: laptopScrollRef
// //   });

// //   const progressHeight = useSpring(
// //     useTransform(scrollYProgress, [0, 1], ["0%", "100%"]),
// //     { stiffness: 120, damping: 30 }
// //   );

// //   useEffect(() => {

// //     const outer = outerScrollRef.current;
// //     const laptop = laptopScrollRef.current;

// //     if (!outer || !laptop) return;

// //     const handleOuterScroll = () => {

// //       const maxOuter = outer.scrollHeight - outer.clientHeight;
// //       if (maxOuter <= 0) return;

// //       let progress = outer.scrollTop / maxOuter;
// //       progress = Math.min(Math.max(progress, 0), 1);

// //       const maxLaptop = laptop.scrollHeight - laptop.clientHeight;
// //       laptop.scrollTop = progress * maxLaptop;

// //       const index = Math.round(progress * (FEATURES.length - 1));
// //       setActive(index);
// //     };

// //     outer.addEventListener("scroll", handleOuterScroll);

// //     return () => {
// //       outer.removeEventListener("scroll", handleOuterScroll);
// //     };

// //   }, []);

// //   return (
// //     <section className="relative py-24 bg-[#FAF9F6] overflow-hidden">

// //       {/* background glow */}
// //       <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-yellow-200/30 blur-[140px] rounded-full"/>

// //       <style>{`
// //         .hide-scrollbar::-webkit-scrollbar{
// //           display:none;
// //         }
// //         .hide-scrollbar{
// //           -ms-overflow-style:none;
// //           scrollbar-width:none;
// //         }
// //       `}</style>

// //       <div className="max-w-6xl mx-auto px-6">

// //         {/* Heading */}

// //         <div className="text-center mb-16 max-w-2xl mx-auto">

// //           <h2 className="text-4xl font-semibold tracking-tight leading-tight">
// //             The Smartest Way to Manage Your Legal Practice
// //           </h2>

// //           <p className="text-gray-600 mt-5 text-lg">
// //             Expand your reach, streamline workflows and manage cases effortlessly.
// //           </p>

// //         </div>


// //         {/* Layout */}

// //         <div className="grid lg:grid-cols-[1fr_520px_1fr] items-center gap-12">

// //           {/* Left features */}

// //           <div className="space-y-6">

// //             {FEATURES.slice(0,3).map((f, i) => (
// //               <motion.div
// //                 key={i}
// //                 animate={{
// //                   opacity: active === i ? 1 : 0.4,
// //                   x: active === i ? 10 : 0
// //                 }}
// //                 className={`flex items-center gap-3 px-4 py-3 rounded-lg transition
// //                 ${active===i ? "bg-white shadow-sm" : ""}
// //                 `}
// //               >

// //                 <div className={`w-3 h-3 rounded-full ${
// //                   active === i
// //                   ? "bg-gradient-to-r from-yellow-400 to-orange-400 shadow-[0_0_8px_rgba(255,170,0,0.7)]"
// //                   : "bg-gray-300"
// //                 }`} />

// //                 <p className={`${
// //                   active === i
// //                   ? "font-semibold text-black"
// //                   : "text-gray-500"
// //                 }`}>
// //                   {f.title}
// //                 </p>

// //               </motion.div>
// //             ))}

// //           </div>


// //           {/* Laptop */}

// //           <div className="relative flex justify-center">

// //             <div
// //               ref={outerScrollRef}
// //               className="absolute h-[520px] w-[520px] overflow-y-scroll hide-scrollbar"
// //             >
// //               <div className="h-[3500px]" />
// //             </div>

// //             <motion.div
// //               whileHover={{
// //                 scale: 1.06,
// //                 rotateX: 6,
// //                 rotateY: -6
// //               }}
// //               transition={{ type: "spring", stiffness: 200 }}
// //               style={{ perspective: 1200 }}
// //               className="relative p-6 rounded-2xl bg-white/40 backdrop-blur-md border border-white/40 shadow-[0_30px_80px_rgba(0,0,0,0.12)]"
// //             >

// //               <img
// //                 src="/laptoptrans.png"
// //                 className="w-[520px] drop-shadow-[0_40px_100px_rgba(0,0,0,0.4)]"
// //               />

// //               <div
// //                 ref={laptopScrollRef}
// //                 className="absolute top-[27%] left-[17.5%] w-[65%] h-[43%] overflow-y-auto rounded-xl bg-black hide-scrollbar"
// //               >

// //                 {FEATURES.map((f, i) => (
// //                   <img
// //                     key={i}
// //                     src={f.image}
// //                     className="w-full h-full object-cover"
// //                   />
// //                 ))}

// //               </div>

// //             </motion.div>

// //           </div>


// //           {/* Right features */}

// //           <div className="space-y-6">

// //             {FEATURES.slice(3).map((f, i) => (
// //               <motion.div
// //                 key={i}
// //                 animate={{
// //                   opacity: active === i+3 ? 1 : 0.4,
// //                   x: active === i+3 ? -10 : 0
// //                 }}
// //                 className={`flex items-center gap-3 px-4 py-3 rounded-lg transition
// //                 ${active===i+3 ? "bg-white shadow-sm" : ""}
// //                 `}
// //               >

// //                 <div className={`w-3 h-3 rounded-full ${
// //                   active === i+3
// //                   ? "bg-gradient-to-r from-yellow-400 to-orange-400 shadow-[0_0_8px_rgba(255,170,0,0.7)]"
// //                   : "bg-gray-300"
// //                 }`} />

// //                 <p className={`${
// //                   active === i+3
// //                   ? "font-semibold text-black"
// //                   : "text-gray-500"
// //                 }`}>
// //                   {f.title}
// //                 </p>

// //               </motion.div>
// //             ))}

// //           </div>

// //         </div>


// //         {/* Progress */}

// //         <div className="flex justify-center mt-14">

// //           <div className="w-[220px] h-[4px] bg-gray-200 rounded-full overflow-hidden">

// //             <motion.div
// //               className="h-full bg-black"
// //               style={{ width: progressHeight }}
// //             />

// //           </div>

// //         </div>

// //       </div>

// //     </section>
// //   );
// // }









// // //6th
// // import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// // import { useRef, useState, useEffect } from "react";

// // const FEATURES = [
// //   { title: "Dashboard", image: "/legal.png" },
// //   { title: "All Cases", image: "/casemanage.png" },
// //   { title: "Calendar", image: "/calander.png" },
// //   { title: "Export Cases", image: "/Home.png" },
// //   { title: "Expenses", image: "/expenses.png" }
// // ];

// // export default function Features() {

// //   const outerScrollRef = useRef(null);
// //   const laptopScrollRef = useRef(null);
// //   const [active, setActive] = useState(0);

// //   const { scrollYProgress } = useScroll({
// //     container: laptopScrollRef
// //   });

// //   const progressHeight = useSpring(
// //     useTransform(scrollYProgress, [0, 1], ["0%", "100%"]),
// //     { stiffness: 120, damping: 30 }
// //   );

// //   useEffect(() => {

// //     const outer = outerScrollRef.current;
// //     const laptop = laptopScrollRef.current;

// //     if (!outer || !laptop) return;

// //     const handleOuterScroll = () => {

// //       const maxOuter = outer.scrollHeight - outer.clientHeight;
// //       if (maxOuter <= 0) return;

// //       let progress = outer.scrollTop / maxOuter;
// //       progress = Math.min(Math.max(progress, 0), 1);

// //       const maxLaptop = laptop.scrollHeight - laptop.clientHeight;
// //       laptop.scrollTop = progress * maxLaptop;

// //       const index = Math.round(progress * (FEATURES.length - 1));
// //       setActive(index);
// //     };

// //     outer.addEventListener("scroll", handleOuterScroll);

// //     return () => outer.removeEventListener("scroll", handleOuterScroll);

// //   }, []);

// //   return (
// //     <section className="relative py-28 bg-[#FAF9F6] overflow-hidden">

// //       {/* soft background glow */}
// //       <div className="absolute left-1/2 -translate-x-1/2 top-32 w-[800px] h-[400px] bg-yellow-200/40 blur-[150px] rounded-full"/>

// //       <style>{`
// //         .hide-scrollbar::-webkit-scrollbar{
// //           display:none;
// //         }
// //         .hide-scrollbar{
// //           -ms-overflow-style:none;
// //           scrollbar-width:none;
// //         }
// //       `}</style>

// //       <div className="max-w-6xl mx-auto px-6">

// //         {/* Heading */}

// //         <div className="text-center mb-20">

// //           <h2 className="text-5xl font-semibold tracking-tight">
// //             The Smartest Way to Manage Your Legal Practice
// //           </h2>

// //           <p className="text-gray-600 mt-6 text-lg max-w-xl mx-auto">
// //             Expand your reach, streamline workflows, and manage cases
// //             effortlessly with one powerful platform.
// //           </p>

// //         </div>


// //         {/* Product Showcase */}

// //         <div className="relative flex items-center justify-center">

// //           {/* fake scroll area */}

// //           <div
// //             ref={outerScrollRef}
// //             className="absolute h-[520px] w-[520px] overflow-y-scroll hide-scrollbar"
// //           >
// //             <div className="h-[3500px]" />
// //           </div>


// //           {/* laptop */}

// //           <motion.div
// //             whileHover={{
// //               scale: 1.05,
// //               rotateX: 6,
// //               rotateY: -6
// //             }}
// //             transition={{ type: "spring", stiffness: 200 }}
// //             style={{ perspective: 1200 }}
// //             className="relative"
// //           >

// //             <img
// //               src="/laptoptrans.png"
// //               className="w-[540px] drop-shadow-[0_60px_120px_rgba(0,0,0,0.45)]"
// //             />

// //             <div
// //               ref={laptopScrollRef}
// //               className="absolute top-[27%] left-[17.5%] w-[65%] h-[43%] overflow-y-auto rounded-xl bg-black hide-scrollbar"
// //             >

// //               {FEATURES.map((f, i) => (
// //                 <img
// //                   key={i}
// //                   src={f.image}
// //                   className="w-full h-full object-cover"
// //                 />
// //               ))}

// //             </div>

// //           </motion.div>


// //           {/* Floating feature cards */}

// //           {FEATURES.map((f, i) => (

// //             <motion.div
// //               key={i}
// //               animate={{
// //                 scale: active === i ? 1.05 : 0.95,
// //                 opacity: active === i ? 1 : 0.5
// //               }}
// //               className={`
// //               absolute bg-white shadow-lg rounded-xl px-5 py-3
// //               text-sm font-medium border border-gray-100
// //               `}
// //               style={{
// //                 top: i === 0 ? "10%" :
// //                      i === 1 ? "30%" :
// //                      i === 2 ? "70%" :
// //                      i === 3 ? "25%" :
// //                      "60%",
// //                 left: i <= 2 ? "5%" : "75%"
// //               }}
// //             >
// //               {f.title}
// //             </motion.div>

// //           ))}

// //         </div>


// //         {/* Progress */}

// //         <div className="flex justify-center mt-16">

// //           <div className="w-[240px] h-[4px] bg-gray-200 rounded-full overflow-hidden">

// //             <motion.div
// //               className="h-full bg-black"
// //               style={{ width: progressHeight }}
// //             />

// //           </div>

// //         </div>

// //       </div>

// //     </section>
// //   );
// // }









// // //7th  very good  design
// // import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// // import { useRef, useState, useEffect } from "react";

// // const FEATURES = [
// //   { title: "Dashboard", image: "/legal.png" },
// //   { title: "All Cases", image: "/casemanage.png" },
// //   { title: "Calendar", image: "/calander.png" },
// //   { title: "Export Cases", image: "/Home.png" },
// //   { title: "Expenses", image: "/expenses.png" }
// // ];

// // export default function Features() {

// //   const outerScrollRef = useRef(null);
// //   const laptopScrollRef = useRef(null);
// //   const [active, setActive] = useState(0);

// //   const { scrollYProgress } = useScroll({
// //     container: laptopScrollRef
// //   });

// //   const progressHeight = useSpring(
// //     useTransform(scrollYProgress, [0, 1], ["0%", "100%"]),
// //     { stiffness: 120, damping: 30 }
// //   );

// //   useEffect(() => {

// //     const outer = outerScrollRef.current;
// //     const laptop = laptopScrollRef.current;

// //     if (!outer || !laptop) return;

// //     const handleOuterScroll = () => {

// //       const maxOuter = outer.scrollHeight - outer.clientHeight;
// //       if (maxOuter <= 0) return;

// //       let progress = outer.scrollTop / maxOuter;
// //       progress = Math.min(Math.max(progress, 0), 1);

// //       const maxLaptop = laptop.scrollHeight - laptop.clientHeight;
// //       laptop.scrollTop = progress * maxLaptop;

// //       const index = Math.round(progress * (FEATURES.length - 1));
// //       setActive(index);
// //     };

// //     outer.addEventListener("scroll", handleOuterScroll);

// //     return () => outer.removeEventListener("scroll", handleOuterScroll);

// //   }, []);

// //   return (
// //     <section className="relative py-28 bg-[#f4f2ee] overflow-hidden">

// //       {/* Background lighting */}
// //       <div className="absolute right-0 top-0 w-[600px] h-[600px] bg-yellow-200/30 blur-[120px] rounded-full"/>

// //       <style>{`
// //         .hide-scrollbar::-webkit-scrollbar{
// //           display:none;
// //         }
// //         .hide-scrollbar{
// //           -ms-overflow-style:none;
// //           scrollbar-width:none;
// //         }
// //       `}</style>

// //       <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 items-center gap-20">

// //         {/* LEFT CONTENT */}

// //         <div className="max-w-xl">

// //           <h2 className="text-[56px] font-semibold leading-[1.05] tracking-tight text-black">
// //             The Smartest Way
// //             <br/>
// //             to Manage Your
// //             <br/>
// //             Legal Practice.
// //           </h2>

// //           <p className="mt-6 text-lg text-gray-600 leading-relaxed max-w-md">
// //             Expand your reach, streamline your workflow, and get paid faster all in one smart legal tech suite.
// //           </p>

// //           <motion.button
// //             whileHover={{ scale: 1.05 }}
// //             whileTap={{ scale: 0.96 }}
// //             className="mt-8 px-8 py-3 rounded-full bg-[#caa24e] text-white font-medium shadow-lg hover:shadow-xl transition"
// //           >
// //             Get Started
// //           </motion.button>

// //           {/* Feature List */}

// //           <div className="mt-12 space-y-4">

// //             {FEATURES.map((f, i) => (
// //               <motion.div
// //                 key={i}
// //                 animate={{
// //                   opacity: active === i ? 1 : 0.4,
// //                   x: active === i ? 12 : 0
// //                 }}
// //                 className="flex items-center gap-3"
// //               >

// //                 <div className={`w-3 h-3 rounded-full ${
// //                   active === i
// //                     ? "bg-[#caa24e]"
// //                     : "bg-gray-300"
// //                 }`} />

// //                 <p className={`${
// //                   active === i
// //                     ? "font-semibold text-black"
// //                     : "text-gray-500"
// //                 }`}>
// //                   {f.title}
// //                 </p>

// //               </motion.div>
// //             ))}

// //           </div>

// //         </div>


// //         {/* RIGHT SIDE */}

// //         <div className="relative flex justify-center">

// //           <div
// //             ref={outerScrollRef}
// //             className="absolute h-[600px] w-[600px] overflow-y-scroll hide-scrollbar"
// //           >
// //             <div className="h-[3800px]" />
// //           </div>


// //           <motion.div
// //             whileHover={{
// //               scale: 1.05,
// //               rotateX: 6,
// //               rotateY: -6
// //             }}
// //             transition={{ type: "spring", stiffness: 200 }}
// //             style={{ perspective: 1400 }}
// //             className="relative"
// //           >

// //             <img
// //               src="/laptoptrans.png"
// //               className="w-[620px] drop-shadow-[0_60px_140px_rgba(0,0,0,0.45)]"
// //             />

// //             <div
// //               ref={laptopScrollRef}
// //               className="absolute top-[27%] left-[17.5%] w-[65%] h-[43%] overflow-y-auto rounded-xl bg-black hide-scrollbar"
// //             >

// //               {FEATURES.map((f, i) => (
// //                 <img
// //                   key={i}
// //                   src={f.image}
// //                   className="w-full h-full object-cover"
// //                 />
// //               ))}

// //             </div>

// //           </motion.div>


// //           {/* progress bar */}

// //           <div className="absolute right-[-25px] top-1/2 -translate-y-1/2 h-[320px] w-[3px] bg-gray-200 rounded-full overflow-hidden">

// //             <motion.div
// //               className="w-full bg-black"
// //               style={{ height: progressHeight }}
// //             />

// //           </div>

// //         </div>

// //       </div>

// //     </section>
// //   );
// // }









// // //8th most best
// // import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// // import { useRef, useState, useEffect } from "react";

// // const FEATURES = [
// //   { title: "Dashboard", image: "/legal.png" },
// //   { title: "All Cases", image: "/casemanage.png" },
// //   { title: "Calendar", image: "/calander.png" },
// //   { title: "Export Cases", image: "/Home.png" },
// //   { title: "Expenses", image: "/expenses.png" }
// // ];

// // export default function Features() {

// //   const outerScrollRef = useRef(null);
// //   const laptopScrollRef = useRef(null);
// //   const [active, setActive] = useState(0);

// //   const { scrollYProgress } = useScroll({
// //     container: laptopScrollRef
// //   });

// //   const progressHeight = useSpring(
// //     useTransform(scrollYProgress, [0, 1], ["0%", "100%"]),
// //     { stiffness: 120, damping: 30 }
// //   );

// //   useEffect(() => {

// //     const outer = outerScrollRef.current;
// //     const laptop = laptopScrollRef.current;

// //     if (!outer || !laptop) return;

// //     const handleOuterScroll = () => {

// //       const maxOuter = outer.scrollHeight - outer.clientHeight;
// //       if (maxOuter <= 0) return;

// //       let progress = outer.scrollTop / maxOuter;
// //       progress = Math.min(Math.max(progress, 0), 1);

// //       const maxLaptop = laptop.scrollHeight - laptop.clientHeight;
// //       laptop.scrollTop = progress * maxLaptop;

// //       const index = Math.round(progress * (FEATURES.length - 1));
// //       setActive(index);
// //     };

// //     outer.addEventListener("scroll", handleOuterScroll);

// //     return () => outer.removeEventListener("scroll", handleOuterScroll);

// //   }, []);

// //   return (
// //     <section className="relative py-28 bg-[#f4f2ee] overflow-hidden">

// //       <div className="absolute right-0 top-0 w-[600px] h-[600px] bg-yellow-200/30 blur-[120px] rounded-full"/>

// //       <style>{`
// //         .hide-scrollbar::-webkit-scrollbar{
// //           display:none;
// //         }
// //         .hide-scrollbar{
// //           -ms-overflow-style:none;
// //           scrollbar-width:none;
// //         }
// //       `}</style>

// //       <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 items-center gap-20">

// //         {/* LEFT CONTENT */}

// //         <div className="max-w-xl">

// //           <h2 className="text-[56px] font-semibold leading-[1.05] tracking-tight text-black">
// //             The Smartest Way
// //             <br/>
// //             to Manage Your
// //             <br/>
// //             Legal Practice.
// //           </h2>

// //           <p className="mt-6 text-lg text-gray-600 leading-relaxed max-w-md">
// //             Expand your reach, streamline your workflow, and get paid faster all in one smart legal tech suite.
// //           </p>

// //           <motion.button
// //             whileHover={{ scale: 1.05 }}
// //             whileTap={{ scale: 0.96 }}
// //             className="mt-8 px-8 py-3 rounded-full bg-[#caa24e] text-white font-medium shadow-lg hover:shadow-xl transition"
// //           >
// //             Get Started
// //           </motion.button>

// //           <div className="mt-12 space-y-4">

// //             {FEATURES.map((f, i) => (
// //               <motion.div
// //                 key={i}
// //                 animate={{
// //                   opacity: active === i ? 1 : 0.4,
// //                   x: active === i ? 12 : 0
// //                 }}
// //                 className="flex items-center gap-3"
// //               >

// //                 <div className={`w-3 h-3 rounded-full ${
// //                   active === i
// //                     ? "bg-[#caa24e]"
// //                     : "bg-gray-300"
// //                 }`} />

// //                 <p className={`${
// //                   active === i
// //                     ? "font-semibold text-black"
// //                     : "text-gray-500"
// //                 }`}>
// //                   {f.title}
// //                 </p>

// //               </motion.div>
// //             ))}

// //           </div>

// //         </div>


// //         {/* RIGHT SIDE */}

// //         <div className="relative flex justify-center">

// //           <div
// //             ref={outerScrollRef}
// //             className="absolute h-[600px] w-[600px] overflow-y-scroll hide-scrollbar"
// //           >
// //             <div className="h-[3800px]" />
// //           </div>


// //           {/* Transparent Glass Container */}

// //           <div className="relative outline outline-1 outline-gray-400/40 rounded-2xl p-6 bg-white/10 backdrop-blur-sm">

// //             <motion.div
// //               style={{ perspective: 1400 }}
// //               className="relative"
// //             >

// //               <img
// //                 src="/laptoptrans.png"
// //                 className="w-[700px] drop-shadow-[0_60px_140px_rgba(0,0,0,0.45)]"
// //               />

// //               <div
// //                 ref={laptopScrollRef}
// //                 className="absolute top-[27%] left-[17.5%] w-[65%] h-[43%] overflow-y-auto rounded-xl bg-black hide-scrollbar"
// //               >

// //                 {FEATURES.map((f, i) => (
// //                   <img
// //                     key={i}
// //                     src={f.image}
// //                     className="w-full h-full object-cover"
// //                   />
// //                 ))}

// //               </div>

// //             </motion.div>

// //           </div>


// //           {/* progress bar */}

// //           <div className="absolute right-[-25px] top-1/2 -translate-y-1/2 h-[320px] w-[3px] bg-gray-200 rounded-full overflow-hidden">

// //             <motion.div
// //               className="w-full bg-black"
// //               style={{ height: progressHeight }}
// //             />
// //           </div>

// //         </div>

// //       </div>

// //     </section>
// //   );
// // }






// // //full final code
// // import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// // import { useRef, useState, useEffect } from "react";

// // const FEATURES = [
// //   { title: "Dashboard", image: "/legal.png" },
// //   { title: "All Cases", image: "/casemanage.png" },
// //   { title: "Calendar", image: "/calander.png" },
// //   { title: "Export Cases", image: "/Home.png" },
// //   { title: "Expenses", image: "/expenses.png" }
// // ];

// // export default function Features() {

// //   const outerScrollRef = useRef(null);
// //   const laptopScrollRef = useRef(null);
// //   const [active, setActive] = useState(0);

// //   const { scrollYProgress } = useScroll({
// //     container: laptopScrollRef
// //   });

// //   const progressHeight = useSpring(
// //     useTransform(scrollYProgress, [0, 1], ["0%", "100%"]),
// //     { stiffness: 120, damping: 30 }
// //   );

// //   useEffect(() => {

// //     const outer = outerScrollRef.current;
// //     const laptop = laptopScrollRef.current;

// //     if (!outer || !laptop) return;

// //     const handleOuterScroll = () => {

// //       const maxOuter = outer.scrollHeight - outer.clientHeight;
// //       if (maxOuter <= 0) return;

// //       let progress = outer.scrollTop / maxOuter;
// //       progress = Math.min(Math.max(progress, 0), 1);

// //       const maxLaptop = laptop.scrollHeight - laptop.clientHeight;
// //       laptop.scrollTop = progress * maxLaptop;

// //       const index = Math.round(progress * (FEATURES.length - 1));
// //       setActive(index);
// //     };

// //     outer.addEventListener("scroll", handleOuterScroll);

// //     return () => {
// //       outer.removeEventListener("scroll", handleOuterScroll);
// //     };

// //   }, []);

// //   return (
// //     <section className="relative pt-24 py-20 bg-[#FAF9F6] overflow-hidden">

// //       <style>{`
// //         .hide-scrollbar::-webkit-scrollbar{
// //           display:none;
// //         }
// //         .hide-scrollbar{
// //           -ms-overflow-style:none;
// //           scrollbar-width:none;
// //         }
// //       `}</style>

// //       <div className="relative max-w-7xl mx-auto px-6 grid lg:grid-cols-2 items-center gap-28">

// //         {/* LEFT SIDE */}

// //         <div className="max-w-md -mt-10">

// //           <h3 className="text-5xl font-semibold leading-tight tracking-tight">
// //             The Smartest Way to Manage Your Legal Practice.
// //           </h3>

// //           <p className="mt-5 text-base text-gray-600 leading-relaxed">
// //             Expand your reach, streamline your workflow, and get paid faster all in one smart legal tech suite.
// //           </p>

// //           <div className="mt-10 space-y-5">

// //             {FEATURES.map((f, i) => (
// //               <motion.div
// //                 key={i}
// //                 animate={{
// //                   opacity: active === i ? 1 : 0.4,
// //                   x: active === i ? 14 : 0
// //                 }}
// //                 transition={{ duration: 0.35 }}
// //                 className="flex items-center gap-3"
// //               >

// //                 <div
// //                   className={`w-3 h-3 rounded-full transition-all duration-300 ${
// //                     active === i
// //                       ? "bg-gradient-to-r from-yellow-400 to-orange-400 shadow-[0_0_10px_rgba(255,180,50,0.7)]"
// //                       : "bg-gray-300"
// //                   }`}
// //                 />

// //                 <p
// //                   className={`text-base transition-all duration-300 ${
// //                     active === i
// //                       ? "font-semibold text-black"
// //                       : "text-gray-800"
// //                   }`}
// //                 >
// //                   {f.title}
// //                 </p>

// //               </motion.div>
// //             ))}

// //           </div>

// //           <motion.button
// //             whileHover={{ scale: 1.06 }}
// //             whileTap={{ scale: 0.97 }}
// //             className="mt-10 px-8 py-2.5 rounded-full bg-black text-white text-sm font-medium shadow-xl hover:shadow-2xl transition"
// //           >
// //             Get Started →
// //           </motion.button>

// //         </div>


// //         {/* RIGHT SIDE */}

// //         <div className="relative flex justify-center overflow-visible">

// //           <div
// //             ref={outerScrollRef}
// //             className="relative h-[650px] w-[900px] -left-[100px] overflow-y-scroll hide-scrollbar"
// //           >
// //             <div className="h-[4000px]" />
// //           </div>


// //           {/* Laptop Container */}

// //           <div className="absolute inset-0 flex items-center justify-center pointer-events-none">

// //             <div className="relative outline outline-1 outline-gray-400/60 rounded-2xl p-6">

// //               <motion.div
// //                 initial={{ scale: 1 }}
// //                 whileHover={{
// //                   scale: 1.12,
// //                   rotateX: 10,
// //                   rotateY: -10,
// //                   y: -25
// //                 }}
// //                 transition={{
// //                   type: "spring",
// //                   stiffness: 200,
// //                   damping: 20
// //                 }}
// //                 style={{ perspective: 1400 }}
// //               >

// //                 <div className="relative">

// //                   <img
// //                     src="/laptoptrans.png"
// //                     className="relative w-[750px] max-w-none drop-shadow-[0_60px_120px_rgba(0,0,0,0.45)] hover:drop-shadow-[0_80px_160px_rgba(0,0,0,0.55)] transition-all duration-500"
// //                   />

// //                   <div
// //                     ref={laptopScrollRef}
// //                     className="absolute top-[27%] left-[17.5%] w-[65%] h-[43%] overflow-y-auto rounded-xl bg-black hide-scrollbar shadow-inner border border-white/15 ring-1 ring-black/40"
// //                   >

// //                     {FEATURES.map((f, i) => (
// //                       <img
// //                         key={i}
// //                         src={f.image}
// //                         className="w-full h-full object-cover"
// //                       />
// //                     ))}

// //                   </div>

// //                 </div>

// //               </motion.div>

// //             </div>

// //           </div>


// //           <div className="absolute right-[-35px] top-1/2 -translate-y-1/2 h-[340px] w-[3px] bg-gray-200 rounded-full overflow-hidden">

// //             <motion.div
// //               className="w-full bg-yellow-600"
// //               style={{ height: progressHeight }}
// //             />

// //           </div>

// //         </div>

// //       </div>

// //     </section>
// //   );
// // }






















// // import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// // import { useRef, useState, useEffect } from "react";

// // const FEATURES = [
// //   { title: "Dashboard", image: "/legal.png" },
// //   { title: "All Cases", image: "/casemanage.png" },
// //   { title: "Calendar", image: "/calander.png" },
// //   { title: "Export Cases", image: "/Home.png" },
// //   { title: "Expenses", image: "/expenses.png" }
// // ];

// // export default function Features() {

// //   const outerScrollRef = useRef(null);
// //   const laptopScrollRef = useRef(null);
// //   const [active, setActive] = useState(0);

// //   const { scrollYProgress } = useScroll({
// //     container: laptopScrollRef
// //   });

// //   const progressHeight = useSpring(
// //     useTransform(scrollYProgress, [0, 1], ["0%", "100%"]),
// //     { stiffness: 120, damping: 30 }
// //   );

// //   useEffect(() => {

// //     const outer = outerScrollRef.current;
// //     const laptop = laptopScrollRef.current;

// //     if (!outer || !laptop) return;

// //     const handleOuterScroll = () => {

// //       const maxOuter = outer.scrollHeight - outer.clientHeight;
// //       if (maxOuter <= 0) return;

// //       let progress = outer.scrollTop / maxOuter;
// //       progress = Math.min(Math.max(progress, 0), 1);

// //       const maxLaptop = laptop.scrollHeight - laptop.clientHeight;
// //       laptop.scrollTop = progress * maxLaptop;

// //       const index = Math.round(progress * (FEATURES.length - 1));
// //       setActive(index);
// //     };

// //     outer.addEventListener("scroll", handleOuterScroll);

// //     return () => {
// //       outer.removeEventListener("scroll", handleOuterScroll);
// //     };

// //   }, []);

// //   return (
// //      <section className="relative pt-24 py-20 bg-[#FAF9F6] overflow-hidden">
    
// //       <style>{`
// //         .hide-scrollbar::-webkit-scrollbar{
// //           display:none;
// //         }
// //         .hide-scrollbar{
// //           -ms-overflow-style:none;
// //           scrollbar-width:none;
// //         }
// //       `}</style>

// //       <div className="relative max-w-7xl mx-auto px-6 grid lg:grid-cols-2 items-center gap-28">

// //         {/* LEFT SIDE */}

// //         <div className="max-w-md -mt-10">

// //           <h3 className="text-5xl font-semibold leading-tight tracking-tight">
// //             The Smartest Way to Manage Your Legal Practice.
// //           </h3>

// //           <p className="mt-5 text-base text-gray-600 leading-relaxed">
// //             Expand your reach, streamline your workflow, and get paid faster all in one smart legal tech suite.
// //           </p>

// //           <div className="mt-10 space-y-5">

// //             {FEATURES.map((f, i) => (
// //               <motion.div
// //                 key={i}
// //                 animate={{
// //                   opacity: active === i ? 1 : 0.4,
// //                   x: active === i ? 14 : 0
// //                 }}
// //                 transition={{ duration: 0.35 }}

// //                 // ✅ CLICK FUNCTION
// //                 onClick={() => {
// //                   const outer = outerScrollRef.current;
// //                   if (!outer) return;

// //                   const maxOuter = outer.scrollHeight - outer.clientHeight;
// //                   const target = (i / (FEATURES.length - 1)) * maxOuter;

// //                   outer.scrollTo({
// //                     top: target,
// //                     behavior: "smooth"
// //                   });
// //                 }}

// //                 // ✅ POINTER + HOVER
// //                 className="flex items-center gap-3 cursor-pointer hover:opacity-80"
// //               >

// //                 <div
// //                   className={`w-3 h-3 rounded-full transition-all duration-300 ${
// //                     active === i
// //                       ? "bg-gradient-to-r from-yellow-400 to-orange-400 shadow-[0_0_10px_rgba(255,180,50,0.7)]"
// //                       : "bg-gray-300"
// //                   }`}
// //                 />

// //                 <p
// //                   className={`text-base transition-all duration-300 ${
// //                     active === i
// //                       ? "font-semibold text-black"
// //                       : "text-gray-800"
// //                   }`}
// //                 >
// //                   {f.title}
// //                 </p>

// //               </motion.div>
// //             ))}

// //           </div>

// //           <motion.button
// //             whileHover={{ scale: 1.06 }}
// //             whileTap={{ scale: 0.97 }}
// //             className="mt-10 px-8 py-2.5 rounded-full bg-black text-white text-sm font-medium shadow-xl hover:shadow-2xl transition"
// //           >
// //             Get Started →
// //           </motion.button>

// //         </div>

// //         {/* RIGHT SIDE */}

// //         <div className="relative flex justify-center overflow-visible">

// //           <div
// //             ref={outerScrollRef}
// //             className="relative h-[650px] w-[900px] -left-[100px] overflow-y-scroll hide-scrollbar"
// //           >
// //             <div className="h-[4000px]" />
// //           </div>

// //           {/* Laptop Container */}

// //           <div className="absolute inset-0 flex items-center justify-center pointer-events-none">

// //             <div className="relative outline outline-1 outline-gray-400/60 rounded-2xl p-6">

// //               <motion.div
// //                 initial={{ scale: 1 }}
// //                 whileHover={{
// //                   scale: 1.12,
// //                   rotateX: 10,
// //                   rotateY: -10,
// //                   y: -25
// //                 }}
// //                 transition={{
// //                   type: "spring",
// //                   stiffness: 200,
// //                   damping: 20
// //                 }}
// //                 style={{ perspective: 1400 }}
// //               >

// //                 <div className="relative">

// //                   <img
// //                     src="/laptoptrans.png"
// //                     className="relative w-[750px] max-w-none drop-shadow-[0_60px_120px_rgba(0,0,0,0.45)] hover:drop-shadow-[0_80px_160px_rgba(0,0,0,0.55)] transition-all duration-500"
// //                   />

// //                   <div
// //                     ref={laptopScrollRef}
// //                     className="absolute top-[27%] left-[17.5%] w-[65%] h-[43%] overflow-y-auto rounded-xl bg-black hide-scrollbar shadow-inner border border-white/15 ring-1 ring-black/40"
// //                   >

// //                     {FEATURES.map((f, i) => (
// //                       <img
// //                         key={i}
// //                         src={f.image}
// //                         className="w-full h-full object-cover"
// //                       />
// //                     ))}

// //                   </div>

// //                 </div>

// //               </motion.div>

// //             </div>

// //           </div>

// //           {/* RIGHT PROGRESS BAR */}

// //           <div className="absolute right-[-35px] top-1/2 -translate-y-1/2 h-[340px] w-[3px] bg-gray-200 rounded-full overflow-hidden">

// //             <motion.div
// //               className="w-full bg-black"
// //               style={{ height: progressHeight }}
// //             />

// //           </div>

// //         </div>

// //       </div>

// //     </section>
// //   );
// // }
















// // import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// // import { useRef, useState, useEffect } from "react";

// // const FEATURES = [
// //   { title: "Dashboard", image: "/legal.png" },
// //   { title: "All Cases", image: "/casemanage.png" },
// //   { title: "Calendar", image: "/calander.png" },
// //   { title: "Export Cases", image: "/Home.png" },
// //   { title: "Expenses", image: "/expenses.png" }
// // ];

// // export default function Features() {

// //   const outerScrollRef = useRef(null);
// //   const laptopScrollRef = useRef(null);
// //   const [active, setActive] = useState(0);

// //   const { scrollYProgress } = useScroll({
// //     container: laptopScrollRef
// //   });

// //   const progressHeight = useSpring(
// //     useTransform(scrollYProgress, [0, 1], ["0%", "100%"]),
// //     { stiffness: 120, damping: 30 }
// //   );

// //   useEffect(() => {

// //     const outer = outerScrollRef.current;
// //     const laptop = laptopScrollRef.current;

// //     if (!outer || !laptop) return;

// //     const handleOuterScroll = () => {

// //       const maxOuter = outer.scrollHeight - outer.clientHeight;
// //       if (maxOuter <= 0) return;

// //       let progress = outer.scrollTop / maxOuter;
// //       progress = Math.min(Math.max(progress, 0), 1);

// //       const maxLaptop = laptop.scrollHeight - laptop.clientHeight;
// //       laptop.scrollTop = progress * maxLaptop;

// //       const index = Math.round(progress * (FEATURES.length - 1));
// //       setActive(index);
// //     };

// //     outer.addEventListener("scroll", handleOuterScroll);

// //     return () => {
// //       outer.removeEventListener("scroll", handleOuterScroll);
// //     };

// //   }, []);

// //   return (
// //     <section className="relative py-20 bg-[#FAF9F6] overflow-hidden">

// //       <style>{`
// //         .hide-scrollbar::-webkit-scrollbar{
// //           display:none;
// //         }
// //         .hide-scrollbar{
// //           -ms-overflow-style:none;
// //           scrollbar-width:none;
// //         }
// //       `}</style>

// //       <div className="relative max-w-7xl mx-auto px-6 grid lg:grid-cols-2 items-center gap-28">

// //         {/* LEFT SIDE */}
// //         <div className="max-w-md mt-0">

// //           <h3 className="text-5xl font-semibold leading-tight tracking-tight">
// //             The Smartest Way to Manage Your Legal Practice.
// //           </h3>

// //           <p className="mt-5 text-base text-gray-600 leading-relaxed">
// //             Expand your reach, streamline your workflow, and get paid faster all in one smart legal tech suite.
// //           </p>

// //           <div className="mt-10 space-y-5">
// //             {FEATURES.map((f, i) => (
// //               <motion.div
// //                 key={i}
// //                 animate={{
// //                   opacity: active === i ? 1 : 0.4,
// //                   x: active === i ? 14 : 0
// //                 }}
// //                 transition={{ duration: 0.35 }}
// //                 onClick={() => {
// //                   const outer = outerScrollRef.current;
// //                   if (!outer) return;

// //                   const maxOuter = outer.scrollHeight - outer.clientHeight;
// //                   const target = (i / (FEATURES.length - 1)) * maxOuter;

// //                   outer.scrollTo({
// //                     top: target,
// //                     behavior: "smooth"
// //                   });
// //                 }}
// //                 className="flex items-center gap-3 cursor-pointer hover:opacity-80"
// //               >

// //                 <div
// //                   className={`w-3 h-3 rounded-full transition-all duration-300 ${
// //                     active === i
// //                       ? "bg-gradient-to-r from-yellow-400 to-orange-400 shadow-[0_0_10px_rgba(255,180,50,0.7)]"
// //                       : "bg-gray-300"
// //                   }`}
// //                 />

// //                 <p
// //                   className={`text-base transition-all duration-300 ${
// //                     active === i
// //                       ? "font-semibold text-black"
// //                       : "text-gray-800"
// //                   }`}
// //                 >
// //                   {f.title}
// //                 </p>

// //               </motion.div>
// //             ))}
// //           </div>

// //           <motion.button
// //             whileHover={{ scale: 1.06 }}
// //             whileTap={{ scale: 0.97 }}
// //             className="mt-10 px-8 py-2.5 rounded-full bg-black text-white text-sm font-medium shadow-xl hover:shadow-2xl transition"
// //           >
// //             Get Started →
// //           </motion.button>

// //         </div>

// //         {/* RIGHT SIDE */}
// //         <div className="relative flex justify-center overflow-visible top-6">

// //           {/* SCROLL CONTROLLER */}
// //           <div
// //             ref={outerScrollRef}
// //             className="relative h-[550px] w-[900px] -left-[100px] overflow-y-scroll hide-scrollbar"
// //           >
// //             <div className="h-[4000px]" />
// //           </div>

// //           {/* LAPTOP */}
// //           <div className="absolute inset-0 flex items-center justify-center pointer-events-none">

// //             <div className="relative outline outline-1 outline-gray-400/60 rounded-2xl p-6">

// //               <motion.div
// //                 initial={{ scale: 1 }}
// //                 whileHover={{
// //                   scale: 1.12,
// //                   rotateX: 10,
// //                   rotateY: -10,
// //                   y: -25
// //                 }}
// //                 transition={{
// //                   type: "spring",
// //                   stiffness: 200,
// //                   damping: 20
// //                 }}
// //                 style={{ perspective: 1400 }}
// //               >

// //                 <div className="relative">

// //                   <img
// //                     src="/laptoptrans.png"
// //                     className="relative w-[750px] max-w-none drop-shadow-[0_60px_120px_rgba(0,0,0,0.45)] hover:drop-shadow-[0_80px_160px_rgba(0,0,0,0.55)] transition-all duration-500"
// //                   />

// //                   <div
// //                     ref={laptopScrollRef}
// //                     className="absolute top-[27%] left-[17.5%] w-[65%] h-[43%] overflow-y-auto rounded-xl bg-black hide-scrollbar shadow-inner border border-white/15 ring-1 ring-black/40"
// //                   >
// //                     {FEATURES.map((f, i) => (
// //                       <img
// //                         key={i}
// //                         src={f.image}
// //                         className="w-full h-full object-cover"
// //                       />
// //                     ))}
// //                   </div>

// //                 </div>

// //               </motion.div>

// //             </div>

// //           </div>

// //           {/* PROGRESS BAR */}
// //           <div className="absolute right-[-35px] top-1/2 -translate-y-1/2 h-[340px] w-[3px] bg-gray-200 rounded-full overflow-hidden">

// //             <motion.div
// //               className="w-full bg-black"
// //               style={{ height: progressHeight }}
// //             />

// //           </div>

// //         </div>

// //       </div>

// //     </section>
// //   );
// // }




















// ////full final best design
// import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// import { useRef, useState, useEffect } from "react";

// const FEATURES = [
//   { title: "Dashboard", image: "/legal.jpeg" },
//   { title: "All Cases", image: "/casemanage.png" },
//   { title: "Calendar", image: "/calander.jpeg" },
//   { title: "Export Cases", image: "/Home.jpeg" },
//   { title: "Expenses", image: "/expenses.png" }
// ];

// export default function Features() {

//   const outerScrollRef = useRef(null);
//   const laptopScrollRef = useRef(null);
//   const [active, setActive] = useState(0);

//   const { scrollYProgress } = useScroll({
//     container: laptopScrollRef
//   });

//   const progressHeight = useSpring(
//     useTransform(scrollYProgress, [0, 1], ["0%", "100%"]),
//     { stiffness: 120, damping: 30 }
//   );

//   useEffect(() => {

//     const outer = outerScrollRef.current;
//     const laptop = laptopScrollRef.current;

//     if (!outer || !laptop) return;

//     const handleOuterScroll = () => {

//       const maxOuter = outer.scrollHeight - outer.clientHeight;
//       if (maxOuter <= 0) return;

//       let progress = outer.scrollTop / maxOuter;
//       progress = Math.min(Math.max(progress, 0), 1);

//       const maxLaptop = laptop.scrollHeight - laptop.clientHeight;
//       laptop.scrollTop = progress * maxLaptop;

//       const index = Math.round(progress * (FEATURES.length - 1));
//       setActive(index);
//     };

//     outer.addEventListener("scroll", handleOuterScroll);

//     return () => {
//       outer.removeEventListener("scroll", handleOuterScroll);
//     };

//   }, []);

//   return (
//     <section className="relative py-20 bg-white overflow-hidden">

//       <style>{`
//         .hide-scrollbar::-webkit-scrollbar{
//           display:none;
//         }
//         .hide-scrollbar{
//           -ms-overflow-style:none;
//           scrollbar-width:none;
//         }
//       `}</style>

//       <div className="relative max-w-7xl mx-auto px-6 grid lg:grid-cols-2 items-center gap-28">

//         {/* LEFT SIDE */}
//        <div className="max-w-md pt-12 lg:pt-20">

//           <h3 className="text-5xl font-semibold leading-tight tracking-tight">
//             The Smartest Way to Manage Your Legal Practice.
//           </h3>

//           <p className="mt-5 text-base text-gray-600 leading-relaxed">
//             Expand your reach, streamline your workflow, and get paid faster all in one smart legal tech suite.
//           </p>

//           <div className="mt-10 space-y-5">
//             {FEATURES.map((f, i) => (
//               <motion.div
//                 key={i}
//                 animate={{
//                   opacity: active === i ? 1 : 0.4,
//                   x: active === i ? 14 : 0
//                 }}
//                 transition={{ duration: 0.35 }}
//                 onClick={() => {
//                   const outer = outerScrollRef.current;
//                   if (!outer) return;

//                   const maxOuter = outer.scrollHeight - outer.clientHeight;
//                   const target = (i / (FEATURES.length - 1)) * maxOuter;

//                   outer.scrollTo({
//                     top: target,
//                     behavior: "smooth"
//                   });
//                 }}
//                 className="flex items-center gap-3 cursor-pointer hover:opacity-80"
//               >

//                 <div
//                   className={`w-3 h-3 rounded-full transition-all duration-300 ${
//                     active === i
//                       ? "bg-gradient-to-r from-yellow-400 to-orange-400 shadow-[0_0_10px_rgba(255,180,50,0.7)]"
//                       : "bg-gray-300"
//                   }`}
//                 />

//                 <p
//                   className={`text-base transition-all duration-300 ${
//                     active === i
//                       ? "font-semibold text-black"
//                       : "text-gray-800"
//                   }`}
//                 >
//                   {f.title}
//                 </p>

//               </motion.div>
//             ))}
//           </div>

         

//         </div>

//         {/* RIGHT SIDE */}
//         <div className="relative flex justify-center overflow-visible top-0 right-0">

//           {/* SCROLL CONTROLLER */}
//           <div
//             ref={outerScrollRef}
//             className="relative h-[550px] w-[900px] -left-[100px] overflow-y-scroll hide-scrollbar"
//           >
//             <div className="h-[4000px]" />
//           </div>

//           {/* LAPTOP */}
//            <div className="absolute inset-0 flex items-center justify-center pointer-events-none"> 
        

//             <div className="relative outline outline-1 outline-gray-300/50 rounded-2xl p-6">

//               <motion.div
//                 initial={{ scale: 1 }}
//                 whileHover={{
//                   scale: 1.12,
//                   rotateX: 10,
//                   rotateY: -10,
//                   y: -25
//                 }}
//                 transition={{
//                   type: "spring",
//                   stiffness: 200,
//                   damping: 20
//                 }}
//                 style={{ perspective: 1400 }}
//               >
//  {/* <motion.button
//             whileHover={{ scale: 1.06 }}
//             whileTap={{ scale: 0.97 }}
//             className="mt-10 px-8 py-2.5 rounded-full bg-black text-white text-sm font-medium shadow-xl hover:shadow-2xl transition"
//           >
//             Get Started →
//           </motion.button> */}
//                 <div className="relative">

//                   <img
//                     src="/laptoptrans.png"
//                     className="relative w-[750px] max-w-none drop-shadow-[0_60px_120px_rgba(0,0,0,0.45)] hover:drop-shadow-[0_80px_160px_rgba(0,0,0,0.55)] transition-all duration-500"
//                   />

//                   <div
//                     ref={laptopScrollRef}
//                     className="absolute top-[27%] left-[17.5%] w-[65%] h-[43%] overflow-y-auto rounded-xl bg-black hide-scrollbar shadow-inner border border-white/15 ring-1 ring-black/40"
//                   >
//                     {FEATURES.map((f, i) => (
//                       <img
//                         key={i}
//                         src={f.image}
//                         className="w-full h-full object-cover"
//                       />
//                     ))}
//                   </div>

//                 </div>

//               </motion.div>

//             </div>

//           </div>

//           {/* PROGRESS BAR */}
//           <div className="absolute right-[-35px] top-1/2 -translate-y-1/2 h-[340px] w-[3px] bg-gray-200 rounded-full overflow-hidden">

//             <motion.div
//               className="w-full bg-black"
//               style={{ height: progressHeight }}
//             />

//           </div>

//         </div>

//       </div>

//     </section>
//   );
// }















// // "use client";

// // import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// // import { useRef, useState, useEffect } from "react";

// // const FEATURES = [
// //   { title: "Dashboard", image: "homepage_dashboard.png" },
// //   { title: "All Cases", image: "homepage_allcase.png" },
// //   { title: "Calendar", image: "homepage_calander.png" },
// //   { title: "Export Cases", image: "homepage_findcases.png" },
// //   { title: "Expenses", image: "homepage_expenses.png" }
// // ];

// // export default function Features() {
// //   const outerScrollRef = useRef(null);
// //   const laptopScrollRef = useRef(null);
// //   const [active, setActive] = useState(0);

// //   const { scrollYProgress } = useScroll({
// //     container: laptopScrollRef
// //   });

// //   const progressHeight = useSpring(
// //     useTransform(scrollYProgress, [0, 1], ["0%", "100%"]),
// //     { stiffness: 120, damping: 30 }
// //   );

// //   useEffect(() => {
// //     const outer = outerScrollRef.current;
// //     const laptop = laptopScrollRef.current;

// //     if (!outer || !laptop) return;

// //     const handleOuterScroll = () => {
// //       const maxOuter = outer.scrollHeight - outer.clientHeight;
// //       if (maxOuter <= 0) return;

// //       let progress = outer.scrollTop / maxOuter;
// //       progress = Math.min(Math.max(progress, 0), 1);

// //       const maxLaptop = laptop.scrollHeight - laptop.clientHeight;

// //       // ✅ FIXED SCROLL
// //       laptop.scrollTop = progress * maxLaptop;

// //       const index = Math.round(progress * (FEATURES.length - 1));
// //       setActive(index);
// //     };

// //     outer.addEventListener("scroll", handleOuterScroll);

// //     return () => {
// //       outer.removeEventListener("scroll", handleOuterScroll);
// //     };
// //   }, []);

// //   return (
// //     <section className="relative py-16 lg:py-20 bg-white overflow-hidden">
// //       <style>{`
// //         .hide-scrollbar::-webkit-scrollbar{
// //           display:none;
// //         }
// //         .hide-scrollbar{
// //           -ms-overflow-style:none;
// //           scrollbar-width:none;
// //         }
// //       `}</style>

// //       <div className="relative max-w-7xl mx-auto px-4 sm:px-6 flex flex-col lg:grid lg:grid-cols-2 items-center gap-12 lg:gap-28">

// //         {/* TEXT */}
// //         <div className="max-w-md pt-10 lg:pt-20 text-center lg:text-left mx-auto lg:mx-0 order-1 lg:order-none">
// //           <h3 className="text-3xl sm:text-4xl lg:text-5xl font-semibold leading-tight tracking-tight">
// //             The Smartest Way to Manage Your Legal Cases.
// //           </h3>

// //           <p className="mt-4 text-sm sm:text-base text-gray-600 leading-relaxed px-2 lg:px-0">
// //             Expand your reach, streamline your workflow, and get paid faster all in one smart legal tech suite.
// //           </p>

// //           {/* DESKTOP FEATURES */}
// //           <div className="mt-8 space-y-4 hidden lg:block">
// //             {FEATURES.map((f, i) => (
// //               <motion.div
// //                 key={i}
// //                 animate={{
// //                   opacity: active === i ? 1 : 0.4,
// //                   x: active === i ? 14 : 0
// //                 }}
// //                 transition={{ duration: 0.35 }}
// //                 onClick={() => {
// //                   const outer = outerScrollRef.current;
// //                   if (!outer) return;

// //                   const maxOuter = outer.scrollHeight - outer.clientHeight;
// //                   const target = (i / (FEATURES.length - 1)) * maxOuter;

// //                   outer.scrollTo({
// //                     top: target,
// //                     behavior: "smooth"
// //                   });
// //                 }}
// //                 className="flex items-center gap-3 cursor-pointer"
// //               >
// //                 <div className={`w-3 h-3 rounded-full ${
// //                   active === i
// //                     ? "bg-gradient-to-r from-yellow-400 to-orange-400"
// //                     : "bg-gray-300"
// //                 }`} />
// //                 <p className={`${active === i ? "font-semibold text-black" : "text-gray-800"}`}>
// //                   {f.title}
// //                 </p>
// //               </motion.div>
// //             ))}
// //           </div>
// //         </div>

// //         {/* LAPTOP */}
// //         <div className="relative flex justify-center overflow-visible mt-6 lg:mt-0 order-2 lg:order-none">

// //           <div
// //             ref={outerScrollRef}
// //             className="relative h-[400px] sm:h-[500px] lg:h-[550px] w-full max-w-[900px] lg:-left-[100px] overflow-y-scroll hide-scrollbar"
// //           >
// //             <div className="h-[4000px]" />
// //           </div>

// //           <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
// //             <div className="relative outline outline-1 outline-gray-300/50 rounded-2xl p-4 sm:p-6">

// //               <motion.div
// //                 initial={{ scale: 1 }}
// //                 whileHover={{
// //                   scale: 1.12,
// //                   rotateX: 10,
// //                   rotateY: -10,
// //                   y: -25
// //                 }}
// //                 transition={{
// //                   type: "spring",
// //                   stiffness: 200,
// //                   damping: 20
// //                 }}
// //                 style={{ perspective: 1400 }}
// //               >
// //                 <div className="relative">

// //                   {/* BIGGER LAPTOP */}
// //                   <img
// //                     src="/laptoptrans.png"
// //                     className="relative w-[460px] sm:w-[600px] lg:w-[750px] max-w-none"
// //                   />

// //                   {/* SCREEN */}
// //                   <div
// //                     ref={laptopScrollRef}
// //                     className="absolute top-[24%] left-[15%] w-[70%] h-[48%] overflow-y-auto rounded-xl bg-black hide-scrollbar"
// //                   >
// //                     {FEATURES.map((f, i) => (
// //                       <img
// //                         key={i}
// //                         src={f.image}
// //                         className="w-full h-auto object-cover"
// //                       />
// //                     ))}
// //                   </div>

// //                 </div>
// //               </motion.div>
// //             </div>
// //           </div>
// //         </div>

// //         {/* MOBILE FEATURES (MCQ STYLE) */}
// //         <div className="mt-10 grid grid-cols-2 gap-5 lg:hidden order-3 max-w-[320px] mx-auto">

// //           {FEATURES.slice(0, 4).map((f, i) => (
// //             <motion.div
// //               key={i}
// //               onClick={() => {
// //                 const outer = outerScrollRef.current;
// //                 if (!outer) return;

// //                 const maxOuter = outer.scrollHeight - outer.clientHeight;
// //                 const target = (i / (FEATURES.length - 1)) * maxOuter;

// //                 outer.scrollTo({ top: target, behavior: "smooth" });
// //               }}
// //               className={`flex items-center gap-2 justify-center text-sm cursor-pointer p-2 rounded-lg
// //               ${active === i ? "bg-yellow-100 font-semibold" : "bg-gray-100"}`}
// //             >
// //               <div className={`w-2.5 h-2.5 rounded-full ${
// //                 active === i ? "bg-yellow-400" : "bg-gray-400"
// //               }`} />
// //               {f.title}
// //             </motion.div>
// //           ))}

// //           {/* CENTER LAST */}
// //           <div className="col-span-2 flex justify-center">
// //             <motion.div
// //               onClick={() => {
// //                 const outer = outerScrollRef.current;
// //                 if (!outer) return;

// //                 const maxOuter = outer.scrollHeight - outer.clientHeight;
// //                 const target = (4 / (FEATURES.length - 1)) * maxOuter;

// //                 outer.scrollTo({ top: target, behavior: "smooth" });
// //               }}
// //               className={`flex items-center gap-2 text-sm cursor-pointer p-2 rounded-lg
// //               ${active === 4 ? "bg-yellow-100 font-semibold" : "bg-gray-100"}`}
// //             >
// //               <div className={`w-2.5 h-2.5 rounded-full ${
// //                 active === 4 ? "bg-yellow-400" : "bg-gray-400"
// //               }`} />
// //               Expenses
// //             </motion.div>
// //           </div>

// //         </div>

// //         {/* PROGRESS BAR */}
// //         <div className="hidden lg:block absolute right-[-35px] top-1/2 -translate-y-1/2 h-[340px] w-[3px] bg-gray-200 rounded-full overflow-hidden">
// //           <motion.div className="w-full bg-black" style={{ height: progressHeight }} />
// //         </div>

// //       </div>
// //     </section>
// //   );
// // }





















// "use client";

// import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// import { useRef, useState, useEffect } from "react";

// const FEATURES = [
//   { title: "Dashboard", image: "homepage_dashboard.png" },
//   { title: "All Cases", image: "homepage_allcase.png" },
//   { title: "Calendar", image: "homepage_calander.png" },
//   { title: "Export Cases", image: "homepage_findcases.png" },
//   { title: "Expenses", image: "homepage_expenses.png" }
// ];

// export default function Features() {
//   const outerScrollRef = useRef(null);
//   const laptopScrollRef = useRef(null);
//   const mobileScreenRef = useRef(null);
//   const [active, setActive] = useState(0);

//   const { scrollYProgress } = useScroll({
//     container: laptopScrollRef
//   });

//   const progressHeight = useSpring(
//     useTransform(scrollYProgress, [0, 1], ["0%", "100%"]),
//     { stiffness: 120, damping: 30 }
//   );

//   useEffect(() => {
//     const outer = outerScrollRef.current;
//     const laptop = laptopScrollRef.current;

//     if (!outer || !laptop) return;

//     const handleOuterScroll = () => {
//       const maxOuter = outer.scrollHeight - outer.clientHeight;
//       if (maxOuter <= 0) return;

//       let progress = outer.scrollTop / maxOuter;
//       progress = Math.min(Math.max(progress, 0), 1);

//       const maxLaptop = laptop.scrollHeight - laptop.clientHeight;
//       laptop.scrollTop = progress * maxLaptop;

//       const index = Math.round(progress * (FEATURES.length - 1));
//       setActive(index);
//     };

//     outer.addEventListener("scroll", handleOuterScroll);
//     return () => outer.removeEventListener("scroll", handleOuterScroll);
//   }, []);

//   /* Scroll the desktop outer container to a specific feature index */
//   const scrollToFeature = (i) => {
//     const outer = outerScrollRef.current;
//     if (!outer) return;
//     const maxOuter = outer.scrollHeight - outer.clientHeight;
//     const target = (i / (FEATURES.length - 1)) * maxOuter;
//     outer.scrollTo({ top: target, behavior: "smooth" });
//   };

//   /* Scroll the mobile screen to a specific feature index */
//   const scrollMobileToFeature = (i) => {
//     const screen = mobileScreenRef.current;
//     if (!screen) return;
//     const maxScroll = screen.scrollHeight - screen.clientHeight;
//     const target = (i / (FEATURES.length - 1)) * maxScroll;
//     screen.scrollTo({ top: target, behavior: "smooth" });
//     setActive(i);
//   };

//   /* Sync mobile screen scroll → active dot */
//   useEffect(() => {
//     const screen = mobileScreenRef.current;
//     if (!screen) return;
//     const onScroll = () => {
//       const max = screen.scrollHeight - screen.clientHeight;
//       if (max <= 0) return;
//       const progress = screen.scrollTop / max;
//       setActive(Math.round(progress * (FEATURES.length - 1)));
//     };
//     screen.addEventListener("scroll", onScroll);
//     return () => screen.removeEventListener("scroll", onScroll);
//   }, []);

//   return (
//     <section className="relative py-16 lg:py-20 bg-white overflow-hidden">
//       <style>{`
//         .hide-scrollbar::-webkit-scrollbar { display: none; }
//         .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
//       `}</style>

//       <div className="relative max-w-7xl mx-auto px-4 sm:px-6 flex flex-col lg:grid lg:grid-cols-2 items-center gap-12 lg:gap-28">

//         {/* ── TEXT COLUMN ── */}
//         <div className="max-w-md pt-10 lg:pt-20 text-center lg:text-left mx-auto lg:mx-0 order-1 lg:order-none">
//           <h3 className="text-3xl sm:text-4xl lg:text-5xl font-semibold leading-tight tracking-tight">
//             The Smartest Way to Manage Your Legal Cases.
//           </h3>

//           <p className="mt-4 text-sm sm:text-base text-gray-600 leading-relaxed px-2 lg:px-0">
//             Expand your reach, streamline your workflow, and get paid faster — all in one smart legal tech suite.
//           </p>

//           {/* Desktop feature list */}
//           <div className="mt-8 space-y-4 hidden lg:block">
//             {FEATURES.map((f, i) => (
//               <motion.div
//                 key={i}
//                 animate={{ opacity: active === i ? 1 : 0.4, x: active === i ? 14 : 0 }}
//                 transition={{ duration: 0.35 }}
//                 onClick={() => scrollToFeature(i)}
//                 className="flex items-center gap-3 cursor-pointer"
//               >
//                 <div className={`w-3 h-3 rounded-full flex-shrink-0 ${
//                   active === i ? "bg-gradient-to-r from-yellow-400 to-orange-400" : "bg-gray-300"
//                 }`} />
//                 <p className={`${active === i ? "font-semibold text-black" : "text-gray-800"}`}>
//                   {f.title}
//                 </p>
//               </motion.div>
//             ))}
//           </div>
//         </div>

//         {/* ── LAPTOP (DESKTOP) ── */}
//         <div className="relative justify-center overflow-visible mt-6 lg:mt-0 order-2 lg:order-none hidden lg:flex">

//           {/* Invisible tall div that captures outer scroll */}
//           <div
//             ref={outerScrollRef}
//             className="relative h-[550px] w-full max-w-[900px] lg:-left-[100px] overflow-y-scroll hide-scrollbar"
//           >
//             <div className="h-[4000px]" />
//           </div>

//           <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
//             <div className="relative outline outline-1 outline-gray-300/50 rounded-2xl p-4 sm:p-6">
//               <motion.div
//                 initial={{ scale: 1 }}
//                 whileHover={{ scale: 1.06, rotateX: 6, rotateY: -6, y: -16 }}
//                 transition={{ type: "spring", stiffness: 200, damping: 20 }}
//                 style={{ perspective: 1400 }}
//               >
//                 <div className="relative inline-block">

//                   {/* Laptop shell image */}
//                   <img
//                     src="/laptoptrans.png"
//                     alt="laptop"
//                     className="relative w-[460px] sm:w-[600px] lg:w-[750px] max-w-none block"
//                     draggable={false}
//                   />

//                   {/*
//                     ── SCREEN OVERLAY ──
//                     Positioned to sit exactly inside the laptop bezel.
//                     Adjust top / left / width / height percentages to match your
//                     specific laptoptrans.png artwork if needed.
//                   */}
//                   <div
//                     ref={laptopScrollRef}
//                     className="absolute overflow-y-auto hide-scrollbar bg-black"
//                     style={{
//                       /* Fine-tune these four values to fit your bezel */
//                       top: "6.5%",
//                       left: "13%",
//                       width: "74%",
//                       height: "72%",
//                       borderRadius: "4px",
//                     }}
//                   >
//                     {FEATURES.map((f, i) => (
//                       <img
//                         key={i}
//                         src={f.image}
//                         alt={f.title}
//                         className="w-full block"
//                         style={{ objectFit: "cover", objectPosition: "top" }}
//                       />
//                     ))}
//                   </div>

//                 </div>
//               </motion.div>
//             </div>
//           </div>
//         </div>

//         {/* ── MOBILE LAPTOP ── */}
//         <div className="relative flex justify-center w-full mt-4 order-2 lg:hidden">
//           <div className="relative inline-block w-full max-w-[340px] sm:max-w-[440px]">

//             {/* Laptop shell */}
//             <img
//               src="/laptoptrans.png"
//               alt="laptop"
//               className="w-full block"
//               draggable={false}
//             />

//             {/*
//               Mobile screen overlay — scrollable so users can swipe through screenshots.
//               Adjust top/left/width/height to match your laptoptrans.png bezel.
//             */}
//             <div
//               ref={mobileScreenRef}
//               className="absolute overflow-y-auto hide-scrollbar bg-black"
//               style={{
//                 top: "6.5%",
//                 left: "13%",
//                 width: "74%",
//                 height: "72%",
//                 borderRadius: "4px",
//                 WebkitOverflowScrolling: "touch",
//                 pointerEvents: "auto",
//               }}
//             >
//               {FEATURES.map((f, i) => (
//                 <img
//                   key={i}
//                   src={f.image}
//                   alt={f.title}
//                   className="w-full block"
//                   style={{ objectFit: "cover", objectPosition: "top" }}
//                 />
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* ── MOBILE FEATURE BUTTONS (clickable) ── */}
//         <div className="mt-6 grid grid-cols-2 gap-3 lg:hidden order-3 w-full max-w-[320px] mx-auto">
//           {FEATURES.slice(0, 4).map((f, i) => (
//             <motion.button
//               key={i}
//               whileTap={{ scale: 0.95 }}
//               onClick={() => scrollMobileToFeature(i)}
//               className={`flex items-center gap-2 justify-center text-sm font-medium p-2.5 rounded-xl transition-colors ${
//                 active === i
//                   ? "bg-yellow-100 text-yellow-800 shadow-sm"
//                   : "bg-gray-100 text-gray-700"
//               }`}
//             >
//               <div className={`w-2.5 h-2.5 rounded-full flex-shrink-0 ${
//                 active === i ? "bg-yellow-400" : "bg-gray-400"
//               }`} />
//               {f.title}
//             </motion.button>
//           ))}

//           {/* 5th item centred */}
//           <div className="col-span-2 flex justify-center">
//             <motion.button
//               whileTap={{ scale: 0.95 }}
//               onClick={() => scrollMobileToFeature(4)}
//               className={`flex items-center gap-2 text-sm font-medium p-2.5 px-5 rounded-xl transition-colors ${
//                 active === 4
//                   ? "bg-yellow-100 text-yellow-800 shadow-sm"
//                   : "bg-gray-100 text-gray-700"
//               }`}
//             >
//               <div className={`w-2.5 h-2.5 rounded-full flex-shrink-0 ${
//                 active === 4 ? "bg-yellow-400" : "bg-gray-400"
//               }`} />
//               Expenses
//             </motion.button>
//           </div>
//         </div>

//         {/* ── DESKTOP PROGRESS BAR ── */}
//         <div className="hidden lg:block absolute right-[-35px] top-1/2 -translate-y-1/2 h-[340px] w-[3px] bg-gray-200 rounded-full overflow-hidden">
//           <motion.div className="w-full bg-black" style={{ height: progressHeight }} />
//         </div>

//       </div>
//     </section>
//   );
// }




























































// "use client";

// import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// import { useRef, useState, useEffect } from "react";

// const FEATURES = [
//   { title: "Dashboard",    image: "homepage_dashboard.png" },
//   { title: "All Cases",    image: "homepage_allcase.png" },
//   { title: "Calendar",     image: "homepage_calander.png" },
//   { title: "Export Cases", image: "homepage_findcases.png" },
//   { title: "Expenses",     image: "homepage_expenses.png" },
// ];

// const SCREEN_STYLE = {
//   position: "absolute",
//   top: "6%",
//   left: "13%",
//   width: "74%",
//   height: "72%",
//   borderRadius: "6px",
//   overflow: "hidden",
// };

// const SNAP_CONTAINER_STYLE = {
//   width:                  "100%",
//   height:                 "100%",
//   overflowY:              "scroll",
//   overflowX:              "hidden",   // ← no horizontal overflow ever
//   scrollSnapType:         "y mandatory",
//   WebkitOverflowScrolling:"touch",
//   msOverflowStyle:        "none",
//   scrollbarWidth:         "none",
// };
// const SLIDE_STYLE = {
//   width: "100%",
//   height: "100%",   // keep same
//   minHeight: "100%", // 🔥 important
//   flexShrink: 0,
//   scrollSnapAlign: "start",
//   scrollSnapStop: "always",
//   overflow: "hidden",
// };

// const IMG_STYLE = {
//   display:         "block",
//   width:           "100%",
//   height:          "100%",
//   objectFit:       "cover",       // fills slide, crops if needed
//   objectPosition:  "top center",
//      // never wider than parent
// };

// function snapTo(container, i) {
//   if (!container) return;
//   container.scrollTo({ top: i * container.clientHeight, behavior: "smooth" });
// }

// export default function Features() {
//   const outerScrollRef = useRef(null);
//   const desktopScreen  = useRef(null);
//   const mobileScreen   = useRef(null);
//   const [active, setActive] = useState(0);

//   const { scrollYProgress } = useScroll({ container: desktopScreen });
//   const progressHeight = useSpring(
//     useTransform(scrollYProgress, [0, 1], ["0%", "100%"]),
//     { stiffness: 120, damping: 30 }
//   );

//   useEffect(() => {
//     const outer  = outerScrollRef.current;
//     const screen = desktopScreen.current;
//     if (!outer || !screen) return;
//     const onScroll = () => {
//       const maxOuter = outer.scrollHeight - outer.clientHeight;
//       if (maxOuter <= 0) return;
//       const progress = Math.min(Math.max(outer.scrollTop / maxOuter, 0), 1);
//       const idx = Math.round(progress * (FEATURES.length - 1));
//       snapTo(screen, idx);
//       setActive(idx);
//     };
//     outer.addEventListener("scroll", onScroll);
//     return () => outer.removeEventListener("scroll", onScroll);
//   }, []);

//   const scrollToFeature = (i) => {
//     const outer = outerScrollRef.current;
//     if (!outer) return;
//     const maxOuter = outer.scrollHeight - outer.clientHeight;
//     outer.scrollTo({ top: (i / (FEATURES.length - 1)) * maxOuter, behavior: "smooth" });
//   };

//   const scrollMobileToFeature = (i) => {
//     snapTo(mobileScreen.current, i);
//     setActive(i);
//   };

//   useEffect(() => {
//     const screen = mobileScreen.current;
//     if (!screen) return;
//     const onScroll = () => {
//       const h = screen.clientHeight;
//       if (!h) return;
//       setActive(Math.round(screen.scrollTop / h));
//     };
//     screen.addEventListener("scroll", onScroll, { passive: true });
//     return () => screen.removeEventListener("scroll", onScroll);
//   }, []);

//   /* ── Shared screen content (slides) ── */
//   const ScreenSlides = () => (
//     <>
//       {FEATURES.map((f, i) => (
//         <div key={i} style={SLIDE_STYLE}>
//           <img src={f.image} alt={f.title} style={IMG_STYLE} />
//         </div>
//       ))}
//     </>
//   );

//   return (
//     <section className="relative py-16 lg:py-20 bg-white overflow-hidden">
//       {/* kill webkit scrollbar on snap containers */}
//       <style>{`
//         .snap-screen::-webkit-scrollbar { display: none; }
//       `}</style>

//       <div className="relative max-w-7xl mx-auto px-4 sm:px-6 flex flex-col lg:grid lg:grid-cols-2 items-center gap-12 lg:gap-28">

//         {/* ── TEXT + DESKTOP FEATURE LIST ── */}
//         <div className="max-w-md pt-10 lg:pt-20 text-center lg:text-left mx-auto lg:mx-0 order-1 lg:order-none">
//           <h3 className="text-3xl sm:text-4xl lg:text-5xl font-semibold leading-tight tracking-tight">
//             The Smartest Way to Manage Your Legal Cases.
//           </h3>
//           <p className="mt-4 text-sm sm:text-base text-gray-600 leading-relaxed px-2 lg:px-0">
//             Expand your reach, streamline your workflow, and get paid faster — all in one smart legal tech suite.
//           </p>
//           <div className="mt-8 space-y-4 hidden lg:block">
//             {FEATURES.map((f, i) => (
//               <motion.div
//                 key={i}
//                 animate={{ opacity: active === i ? 1 : 0.4, x: active === i ? 14 : 0 }}
//                 transition={{ duration: 0.35 }}
//                 onClick={() => scrollToFeature(i)}
//                 className="flex items-center gap-3 cursor-pointer"
//               >
//                 <div className={`w-3 h-3 rounded-full flex-shrink-0 ${
//                   active === i ? "bg-gradient-to-r from-yellow-400 to-orange-400" : "bg-gray-300"
//                 }`} />
//                 <p className={active === i ? "font-semibold text-black" : "text-gray-800"}>
//                   {f.title}
//                 </p>
//               </motion.div>
//             ))}
//           </div>
//         </div>

//         {/* ── DESKTOP LAPTOP ── */}
//         <div className="relative justify-center overflow-visible mt-6 lg:mt-0 order-2 lg:order-none hidden lg:flex">
//           {/* Scroll proxy */}
//           <div
//             ref={outerScrollRef}
//             style={{ overflowY: "scroll", overflowX: "hidden" }}
//             className="relative h-[550px] w-full max-w-[900px] lg:-left-[100px]"
//             // hide scrollbar via style since className can't target pseudo
//           >
//             <style>{`.outer-proxy::-webkit-scrollbar{display:none}`}</style>
//             <div className="h-[4000px]" />
//           </div>

//           <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
//             <div className="relative outline outline-1 outline-gray-300/50 rounded-2xl p-4 sm:p-6">
//               <motion.div
//                 initial={{ scale: 1 }}
//                 whileHover={{ scale: 1.06, rotateX: 6, rotateY: -6, y: -16 }}
//                 transition={{ type: "spring", stiffness: 200, damping: 20 }}
//                 style={{ perspective: 1400 }}
//               >
//                 {/* wrapper: position:relative so absolute children anchor here */}
//                 <div style={{ position: "relative", display: "inline-block", lineHeight: 0 }}>
//                   <img
//                     src="/laptoptrans.png"
//                     alt="laptop"
//                     style={{ display: "block", width: "750px", maxWidth: "none" }}
//                     draggable={false}
//                   />

//                   {/* SCREEN — overflow:hidden clips everything */}
//                   <div style={SCREEN_STYLE}>
//                     <div
//                       ref={desktopScreen}
//                       className="snap-screen"
//                       style={SNAP_CONTAINER_STYLE}
//                     >
//                       <ScreenSlides />
//                     </div>
//                   </div>
//                 </div>
//               </motion.div>
//             </div>
//           </div>
//         </div>

//         {/* ── MOBILE LAPTOP ── */}
//         <div className="relative flex justify-center w-full mt-4 order-2 lg:hidden">
//           <div style={{ position: "relative", display: "inline-block", lineHeight: 0, width: "100%", maxWidth: "360px" }}>
//             <img
//               src="/laptoptrans.png"
//               alt="laptop"
//               style={{ display: "block", width: "100%" }}
//               draggable={false}
//             />

//             {/* SCREEN */}
//             <div style={SCREEN_STYLE}>
//               <div
//                 ref={mobileScreen}
//                 className="snap-screen"
//                 style={{ ...SNAP_CONTAINER_STYLE, pointerEvents: "auto" }}
//               >
//                 <ScreenSlides />
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* ── MOBILE FEATURE BUTTONS ── */}
//         <div className="mt-6 grid grid-cols-2 gap-3 lg:hidden order-3 w-full max-w-[320px] mx-auto">
//           {FEATURES.slice(0, 4).map((f, i) => (
//             <motion.button
//               key={i}
//               whileTap={{ scale: 0.95 }}
//               onClick={() => scrollMobileToFeature(i)}
//               className={`flex items-center gap-2 justify-center text-sm font-medium p-2.5 rounded-xl transition-colors ${
//                 active === i ? "bg-yellow-100 text-yellow-800 shadow-sm" : "bg-gray-100 text-gray-700"
//               }`}
//             >
//               <div className={`w-2.5 h-2.5 rounded-full flex-shrink-0 ${
//                 active === i ? "bg-yellow-400" : "bg-gray-400"
//               }`} />
//               {f.title}
//             </motion.button>
//           ))}
//           <div className="col-span-2 flex justify-center">
//             <motion.button
//               whileTap={{ scale: 0.95 }}
//               onClick={() => scrollMobileToFeature(4)}
//               className={`flex items-center gap-2 text-sm font-medium p-2.5 px-5 rounded-xl transition-colors ${
//                 active === 4 ? "bg-yellow-100 text-yellow-800 shadow-sm" : "bg-gray-100 text-gray-700"
//               }`}
//             >
//               <div className={`w-2.5 h-2.5 rounded-full flex-shrink-0 ${
//                 active === 4 ? "bg-yellow-400" : "bg-gray-400"
//               }`} />
//               Expenses
//             </motion.button>
//           </div>
//         </div>

//         {/* ── DESKTOP PROGRESS BAR ── */}
//         <div className="hidden lg:block absolute right-[-35px] top-1/2 -translate-y-1/2 h-[340px] w-[3px] bg-gray-200 rounded-full overflow-hidden">
//           <motion.div className="w-full bg-black" style={{ height: progressHeight }} />
//         </div>

//       </div>
//     </section>
//   );
// }




















// //final final
// "use client";

// import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// import { useRef, useState, useEffect } from "react";

// const FEATURES = [
//   { title: "Dashboard", image: "homepage_dashboard.png" },
//   { title: "All Cases", image: "homepage_allcase.png" },
//   { title: "Calendar", image: "homepage_calander.png" },
//   { title: "Export Cases", image: "homepage_findcases.png" },
//   { title: "Expenses", image: "homepage_expenses.png" }
// ];

// export default function Features() {
//   const outerScrollRef = useRef(null);
//   const laptopScrollRef = useRef(null);
//   const [active, setActive] = useState(0);

//   const { scrollYProgress } = useScroll({
//     container: laptopScrollRef
//   });

//   const progressHeight = useSpring(
//     useTransform(scrollYProgress, [0, 1], ["0%", "100%"]),
//     { stiffness: 120, damping: 30 }
//   );

//   useEffect(() => {
//     const outer = outerScrollRef.current;
//     const laptop = laptopScrollRef.current;

//     if (!outer || !laptop) return;

//     const handleOuterScroll = () => {
//       const maxOuter = outer.scrollHeight - outer.clientHeight;
//       if (maxOuter <= 0) return;

//       let progress = outer.scrollTop / maxOuter;
//       progress = Math.min(Math.max(progress, 0), 1);

//       const maxLaptop = laptop.scrollHeight - laptop.clientHeight;
//       laptop.scrollTop = progress * maxLaptop;

//       const index = Math.round(progress * (FEATURES.length - 1));
//       setActive(index);
//     };

//     outer.addEventListener("scroll", handleOuterScroll);

//     return () => {
//       outer.removeEventListener("scroll", handleOuterScroll);
//     };
//   }, []);

//   return (
//     <section className="relative py-16 lg:py-20 bg-white overflow-hidden">
//       <style>{`
//         .hide-scrollbar::-webkit-scrollbar{
//           display:none;
//         }
//         .hide-scrollbar{
//           -ms-overflow-style:none;
//           scrollbar-width:none;
//         }
//       `}</style>

//       <div className="relative max-w-7xl mx-auto px-4 sm:px-6 grid lg:grid-cols-2 items-center gap-12 lg:gap-28">

//         {/* LEFT SIDE */}
//         <div className="max-w-md pt-10 lg:pt-20 text-center lg:text-left mx-auto lg:mx-0">

//           <h3 className="text-3xl sm:text-4xl lg:text-5xl font-semibold leading-tight tracking-tight">
//             The Smartest Way to Manage Your Legal Cases.
//           </h3>

//           <p className="mt-4 text-sm sm:text-base text-gray-600 leading-relaxed px-2 lg:px-0">
//             Expand your reach, streamline your workflow, and get paid faster all in one smart legal tech suite.
//           </p>

//           <div className="mt-8 space-y-4">
//             {FEATURES.map((f, i) => (
//               <motion.div
//                 key={i}
//                 animate={{
//                   opacity: active === i ? 1 : 0.4,
//                   x: active === i ? 14 : 0
//                 }}
//                 transition={{ duration: 0.35 }}
//                 onClick={() => {
//                   const outer = outerScrollRef.current;
//                   if (!outer) return;

//                   const maxOuter = outer.scrollHeight - outer.clientHeight;
//                   const target = (i / (FEATURES.length - 1)) * maxOuter;

//                   outer.scrollTo({
//                     top: target,
//                     behavior: "smooth"
//                   });
//                 }}
//                 className="flex items-center justify-center lg:justify-start gap-3 cursor-pointer hover:opacity-80"
//               >
//                 <div
//                   className={`w-3 h-3 rounded-full transition-all duration-300 ${
//                     active === i
//                       ? "bg-gradient-to-r from-yellow-400 to-orange-400 shadow-[0_0_10px_rgba(255,180,50,0.7)]"
//                       : "bg-gray-300"
//                   }`}
//                 />

//                 <p
//                   className={`text-sm sm:text-base transition-all duration-300 ${
//                     active === i
//                       ? "font-semibold text-black"
//                       : "text-gray-800"
//                   }`}
//                 >
//                   {f.title}
//                 </p>
//               </motion.div>
//             ))}
//           </div>
//         </div>

//         {/* RIGHT SIDE */}
//         <div className="relative flex justify-center overflow-visible mt-10 lg:mt-0">

//           {/* SCROLL CONTROLLER */}
//           <div
//             ref={outerScrollRef}
//             className="relative h-[400px] sm:h-[500px] lg:h-[550px] w-full max-w-[900px] lg:-left-[100px] overflow-y-scroll hide-scrollbar"
//           >
//             <div className="h-[4000px]" />
//           </div>

//           {/* LAPTOP */}
//           <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
//             <div className="relative outline outline-1 outline-gray-300/50 rounded-2xl p-4 sm:p-6">

//               <motion.div
//                 initial={{ scale: 1 }}
//                 whileHover={{
//                   scale: 1.12,
//                   rotateX: 10,
//                   rotateY: -10,
//                   y: -25
//                 }}
//                 transition={{
//                   type: "spring",
//                   stiffness: 200,
//                   damping: 20
//                 }}
//                 style={{ perspective: 1400 }}
//               >

//                 <div className="relative">

//                   <img
//                     src="/laptoptrans.png"
//                     className="relative w-[320px] sm:w-[500px] lg:w-[750px] max-w-none drop-shadow-[0_60px_120px_rgba(0,0,0,0.45)] hover:drop-shadow-[0_80px_160px_rgba(0,0,0,0.55)] transition-all duration-500"
//                   />

//                   <div
//                     ref={laptopScrollRef}
//                     className="absolute top-[26%] left-[17%] w-[66%] h-[44%] overflow-y-auto rounded-xl bg-black hide-scrollbar shadow-inner border border-white/15 ring-1 ring-black/40"
//                   >
//                     {FEATURES.map((f, i) => (
//                       <img
//                         key={i}
//                         src={f.image}
//                         className="w-full h-full object-cover"
//                       />
//                     ))}
//                   </div>

//                 </div>

//               </motion.div>
//             </div>
//           </div>

//           {/* PROGRESS BAR */}
//           <div className="hidden lg:block absolute right-[-35px] top-1/2 -translate-y-1/2 h-[340px] w-[3px] bg-gray-200 rounded-full overflow-hidden">
//             <motion.div
//               className="w-full bg-black"
//               style={{ height: progressHeight }}
//             />
//           </div>

//         </div>
//       </div>
//     </section>
//   );
// }




















// "use client";

// import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// import { useRef, useState, useEffect } from "react";

// const FEATURES = [
//   { title: "Dashboard", image: "homepage_dashboard.png" },
//   { title: "All Cases", image: "homepage_allcase.png" },
//   { title: "Calendar", image: "homepage_calander.png" },
//   { title: "Export Cases", image: "homepage_findcases.png" },
//   { title: "Expenses", image: "homepage_expenses.png" }
// ];

// export default function Features() {
//   const outerScrollRef = useRef(null);
//   const laptopScrollRef = useRef(null);
//   const [active, setActive] = useState(0);

//   const { scrollYProgress } = useScroll({
//     container: laptopScrollRef
//   });

//   const progressHeight = useSpring(
//     useTransform(scrollYProgress, [0, 1], ["0%", "100%"]),
//     { stiffness: 120, damping: 30 }
//   );

//   useEffect(() => {
//     const outer = outerScrollRef.current;
//     const laptop = laptopScrollRef.current;

//     if (!outer || !laptop) return;

//     const handleOuterScroll = () => {
//       const maxOuter = outer.scrollHeight - outer.clientHeight;
//       if (maxOuter <= 0) return;

//       let progress = outer.scrollTop / maxOuter;
//       progress = Math.min(Math.max(progress, 0), 1);

//       const maxLaptop = laptop.scrollHeight - laptop.clientHeight;
//       laptop.scrollTop = progress * maxLaptop;

//       const index = Math.round(progress * (FEATURES.length - 1));
//       setActive(index);
//     };

//     outer.addEventListener("scroll", handleOuterScroll);

//     return () => {
//       outer.removeEventListener("scroll", handleOuterScroll);
//     };
//   }, []);

//   return (
//     <section className="relative py-16 lg:py-20 bg-white overflow-hidden">
//       <style>{`
//         .hide-scrollbar::-webkit-scrollbar {
//           display: none;
//         }
//         .hide-scrollbar {
//           -ms-overflow-style: none;
//           scrollbar-width: none;
//         }
//       `}</style>

//       {/* ============ DESKTOP LAYOUT ============ */}
//       <div className="hidden lg:grid relative max-w-7xl mx-auto px-4 sm:px-6 lg:grid-cols-2 items-center gap-12 lg:gap-28">

//         {/* LEFT SIDE */}
//         <div className="max-w-md pt-10 lg:pt-20 text-center lg:text-left mx-auto lg:mx-0">

//           <h3 className="text-3xl sm:text-4xl lg:text-5xl font-semibold leading-tight tracking-tight">
//             The Smartest Way to Manage Your Legal Cases.
//           </h3>

//           <p className="mt-4 text-sm sm:text-base text-gray-600 leading-relaxed px-2 lg:px-0">
//             Expand your reach, streamline your workflow, and get paid faster all in one smart legal tech suite.
//           </p>

//           <div className="mt-8 space-y-4">
//             {FEATURES.map((f, i) => (
//               <motion.div
//                 key={i}
//                 animate={{
//                   opacity: active === i ? 1 : 0.4,
//                   x: active === i ? 14 : 0
//                 }}
//                 transition={{ duration: 0.35 }}
//                 onClick={() => {
//                   const outer = outerScrollRef.current;
//                   if (!outer) return;
//                   const maxOuter = outer.scrollHeight - outer.clientHeight;
//                   const target = (i / (FEATURES.length - 1)) * maxOuter;
//                   outer.scrollTo({ top: target, behavior: "smooth" });
//                 }}
//                 className="flex items-center justify-center lg:justify-start gap-3 cursor-pointer hover:opacity-80"
//               >
//                 <div
//                   className={`w-3 h-3 rounded-full transition-all duration-300 ${
//                     active === i
//                       ? "bg-gradient-to-r from-yellow-400 to-orange-400 shadow-[0_0_10px_rgba(255,180,50,0.7)]"
//                       : "bg-gray-300"
//                   }`}
//                 />
//                 <p
//                   className={`text-sm sm:text-base transition-all duration-300 ${
//                     active === i ? "font-semibold text-black" : "text-gray-800"
//                   }`}
//                 >
//                   {f.title}
//                 </p>
//               </motion.div>
//             ))}
//           </div>
//         </div>

//         {/* RIGHT SIDE */}
//         <div className="relative flex justify-center overflow-visible mt-10 lg:mt-0">

//           {/* SCROLL CONTROLLER */}
//           <div
//             ref={outerScrollRef}
//             className="relative h-[400px] sm:h-[500px] lg:h-[550px] w-full max-w-[900px] lg:-left-[100px] overflow-y-scroll hide-scrollbar"
//           >
//             <div className="h-[4000px]" />
//           </div>

//           {/* LAPTOP */}
//           <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
//             <div className="relative outline outline-1 outline-gray-300/50 rounded-2xl p-4 sm:p-6">
//               <motion.div
//                 initial={{ scale: 1 }}
//                 whileHover={{ scale: 1.12, rotateX: 10, rotateY: -10, y: -25 }}
//                 transition={{ type: "spring", stiffness: 200, damping: 20 }}
//                 style={{ perspective: 1400 }}
//               >
//                 <div className="relative">
//                   <img
//                     src="/laptoptrans.png"
//                     className="relative w-[320px] sm:w-[500px] lg:w-[750px] max-w-none drop-shadow-[0_60px_120px_rgba(0,0,0,0.45)] hover:drop-shadow-[0_80px_160px_rgba(0,0,0,0.55)] transition-all duration-500"
//                   />
//                   <div
//                     ref={laptopScrollRef}
//                     className="absolute top-[26%] left-[17%] w-[66%] h-[44%] overflow-y-auto rounded-xl bg-black hide-scrollbar shadow-inner border border-white/15 ring-1 ring-black/40"
//                   >
//                     {FEATURES.map((f, i) => (
//                       <img key={i} src={f.image} className="w-full h-full object-cover" />
//                     ))}
//                   </div>
//                 </div>
//               </motion.div>
//             </div>
//           </div>

//           {/* PROGRESS BAR */}
//           <div className="hidden lg:block absolute right-[-35px] top-1/2 -translate-y-1/2 h-[340px] w-[3px] bg-gray-200 rounded-full overflow-hidden">
//             <motion.div className="w-full bg-black" style={{ height: progressHeight }} />
//           </div>

//         </div>
//       </div>

//       {/* ============ MOBILE LAYOUT ============ */}
//       <div className="lg:hidden flex flex-col items-center px-5">

//         {/* 1. HEADING & SUBTITLE */}
//         <div className="text-center max-w-sm mb-8">
//           <h3 className="text-3xl font-semibold leading-tight tracking-tight">
//             The Smartest Way to Manage Your Legal Cases.
//           </h3>
//           <p className="mt-4 text-sm text-gray-600 leading-relaxed">
//             Expand your reach, streamline your workflow, and get paid faster all in one smart legal tech suite.
//           </p>
//         </div>

//         {/* 2. LAPTOP MOCKUP */}
//         <div className="relative w-full flex justify-center mb-10">
//           <div className="relative outline outline-1 outline-gray-300/50 rounded-2xl p-3">
//             <div className="relative">
//               <img
//                 src="/laptoptrans.png"
//                 className="w-[320px] drop-shadow-[0_40px_80px_rgba(0,0,0,0.35)]"
//               />
//               {/* Screen — shows the active feature image */}
//               <div className="absolute top-[26%] left-[17%] w-[66%] h-[44%] overflow-hidden rounded-xl bg-black">
//                 <motion.img
//                   key={active}
//                   src={FEATURES[active].image}
//                   className="w-full h-full object-cover"
//                   initial={{ opacity: 0 }}
//                   animate={{ opacity: 1 }}
//                   transition={{ duration: 0.4 }}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* 3. FEATURE GRID — 2 left, 2 right, last centered */}
//         <div className="w-full max-w-xs">

//           {/* First 4 items: 2x2 grid */}
//           <div className="grid grid-cols-2 gap-4 mb-4">
//             {FEATURES.slice(0, 4).map((f, i) => (
//               <motion.button
//                 key={i}
//                 animate={{
//                   opacity: active === i ? 1 : 0.45,
//                   scale: active === i ? 1.03 : 1,
//                 }}
//                 transition={{ duration: 0.3 }}
//                 onClick={() => setActive(i)}
//                 className="flex items-center gap-2.5 px-4 py-3 rounded-xl bg-gray-50 border border-gray-100 shadow-sm hover:shadow-md transition-all duration-200 w-full"
//               >
//                 <div
//                   className={`w-2.5 h-2.5 rounded-full flex-shrink-0 transition-all duration-300 ${
//                     active === i
//                       ? "bg-gradient-to-r from-yellow-400 to-orange-400 shadow-[0_0_8px_rgba(255,180,50,0.7)]"
//                       : "bg-gray-300"
//                   }`}
//                 />
//                 <span
//                   className={`text-sm transition-all duration-300 ${
//                     active === i ? "font-semibold text-black" : "text-gray-700"
//                   }`}
//                 >
//                   {f.title}
//                 </span>
//               </motion.button>
//             ))}
//           </div>

//           {/* 5th item: centered below */}
//           <div className="flex justify-center">
//             <motion.button
//               animate={{
//                 opacity: active === 4 ? 1 : 0.45,
//                 scale: active === 4 ? 1.03 : 1,
//               }}
//               transition={{ duration: 0.3 }}
//               onClick={() => setActive(4)}
//               className="flex items-center gap-2.5 px-4 py-3 rounded-xl bg-gray-50 border border-gray-100 shadow-sm hover:shadow-md transition-all duration-200 w-[calc(50%-8px)]"
//             >
//               <div
//                 className={`w-2.5 h-2.5 rounded-full flex-shrink-0 transition-all duration-300 ${
//                   active === 4
//                     ? "bg-gradient-to-r from-yellow-400 to-orange-400 shadow-[0_0_8px_rgba(255,180,50,0.7)]"
//                     : "bg-gray-300"
//                 }`}
//               />
//               <span
//                 className={`text-sm transition-all duration-300 ${
//                   active === 4 ? "font-semibold text-black" : "text-gray-700"
//                 }`}
//               >
//                 {FEATURES[4].title}
//               </span>
//             </motion.button>
//           </div>

//         </div>
//       </div>

//     </section>
//   );
// }





























// "use client";

// import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// import { useRef, useState, useEffect } from "react";

// const FEATURES = [
//   { title: "Dashboard", image: "homepage_dashboard.png" },
//   { title: "All Cases", image: "homepage_allcase.png" },
//   { title: "Calendar", image: "homepage_calander.png" },
//   { title: "Export Cases", image: "homepage_findcases.png" },
//   { title: "Expenses", image: "homepage_expenses.png" }
// ];

// export default function Features() {
//   const outerScrollRef = useRef(null);
//   const laptopScrollRef = useRef(null);
//   const [active, setActive] = useState(0);

//   const { scrollYProgress } = useScroll({
//     container: laptopScrollRef
//   });

//   const progressHeight = useSpring(
//     useTransform(scrollYProgress, [0, 1], ["0%", "100%"]),
//     { stiffness: 120, damping: 30 }
//   );

//   useEffect(() => {
//     const outer = outerScrollRef.current;
//     const laptop = laptopScrollRef.current;

//     if (!outer || !laptop) return;

//     const handleOuterScroll = () => {
//       const maxOuter = outer.scrollHeight - outer.clientHeight;
//       if (maxOuter <= 0) return;

//       let progress = outer.scrollTop / maxOuter;
//       progress = Math.min(Math.max(progress, 0), 1);

//       const maxLaptop = laptop.scrollHeight - laptop.clientHeight;
//       laptop.scrollTop = progress * maxLaptop;

//       const index = Math.round(progress * (FEATURES.length - 1));
//       setActive(index);
//     };

//     outer.addEventListener("scroll", handleOuterScroll);

//     return () => {
//       outer.removeEventListener("scroll", handleOuterScroll);
//     };
//   }, []);

//   return (
//     <section className="relative py-16 lg:py-20 bg-white overflow-hidden">
//       <style>{`
//         .hide-scrollbar::-webkit-scrollbar {
//           display: none;
//         }
//         .hide-scrollbar {
//           -ms-overflow-style: none;
//           scrollbar-width: none;
//         }
//       `}</style>

//       {/* ============ DESKTOP LAYOUT ============ */}
//       <div className="hidden lg:grid relative max-w-7xl mx-auto px-4 sm:px-6 lg:grid-cols-2 items-center gap-12 lg:gap-28">

//         {/* LEFT SIDE */}
//         <div className="max-w-md pt-10 lg:pt-20 text-center lg:text-left mx-auto lg:mx-0">

//           <h3 className="text-3xl sm:text-4xl lg:text-5xl font-semibold leading-tight tracking-tight">
//             The Smartest Way to Manage Your Legal Cases.
//           </h3>

//           <p className="mt-4 text-sm sm:text-base text-gray-600 leading-relaxed px-2 lg:px-0">
//             Expand your reach, streamline your workflow, and get paid faster all in one smart legal tech suite.
//           </p>

//           <div className="mt-8 space-y-4">
//             {FEATURES.map((f, i) => (
//               <motion.div
//                 key={i}
//                 animate={{
//                   opacity: active === i ? 1 : 0.4,
//                   x: active === i ? 14 : 0
//                 }}
//                 transition={{ duration: 0.35 }}
//                 onClick={() => {
//                   const outer = outerScrollRef.current;
//                   if (!outer) return;
//                   const maxOuter = outer.scrollHeight - outer.clientHeight;
//                   const target = (i / (FEATURES.length - 1)) * maxOuter;
//                   outer.scrollTo({ top: target, behavior: "smooth" });
//                 }}
//                 className="flex items-center justify-center lg:justify-start gap-3 cursor-pointer hover:opacity-80"
//               >
//                 <div
//                   className={`w-3 h-3 rounded-full transition-all duration-300 ${
//                     active === i
//                       ? "bg-gradient-to-r from-yellow-400 to-orange-400 shadow-[0_0_10px_rgba(255,180,50,0.7)]"
//                       : "bg-gray-300"
//                   }`}
//                 />
//                 <p
//                   className={`text-sm sm:text-base transition-all duration-300 ${
//                     active === i ? "font-semibold text-black" : "text-gray-800"
//                   }`}
//                 >
//                   {f.title}
//                 </p>
//               </motion.div>
//             ))}
//           </div>
//         </div>

//         {/* RIGHT SIDE */}
//         <div className="relative flex justify-center overflow-visible mt-10 lg:mt-0">

//           {/* SCROLL CONTROLLER */}
//           <div
//             ref={outerScrollRef}
//             className="relative h-[400px] sm:h-[500px] lg:h-[550px] w-full max-w-[900px] lg:-left-[100px] overflow-y-scroll hide-scrollbar"
//           >
//             <div className="h-[4000px]" />
//           </div>

//           {/* LAPTOP */}
//           <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
//             <div className="relative outline outline-1 outline-gray-300/50 rounded-2xl p-4 sm:p-6">
//               <motion.div
//                 initial={{ scale: 1 }}
//                 whileHover={{ scale: 1.12, rotateX: 10, rotateY: -10, y: -25 }}
//                 transition={{ type: "spring", stiffness: 200, damping: 20 }}
//                 style={{ perspective: 1400 }}
//               >
//                 <div className="relative">
//                   <img
//                     src="/laptoptrans.png"
//                     className="relative w-[320px] sm:w-[500px] lg:w-[750px] max-w-none drop-shadow-[0_60px_120px_rgba(0,0,0,0.45)] hover:drop-shadow-[0_80px_160px_rgba(0,0,0,0.55)] transition-all duration-500"
//                   />
//                   <div
//                     ref={laptopScrollRef}
//                     className="absolute top-[26%] left-[17%] w-[66%] h-[44%] overflow-y-auto rounded-xl bg-black hide-scrollbar shadow-inner border border-white/15 ring-1 ring-black/40"
//                   >
//                     {FEATURES.map((f, i) => (
//                       <img key={i} src={f.image} className="w-full h-full object-cover" />
//                     ))}
//                   </div>
//                 </div>
//               </motion.div>
//             </div>
//           </div>

//           {/* PROGRESS BAR */}
//           <div className="hidden lg:block absolute right-[-35px] top-1/2 -translate-y-1/2 h-[340px] w-[3px] bg-gray-200 rounded-full overflow-hidden">
//             <motion.div className="w-full bg-black" style={{ height: progressHeight }} />
//           </div>

//         </div>
//       </div>

//       {/* ============ MOBILE LAYOUT ============ */}
//       <div className="lg:hidden flex flex-col items-center px-5">

//         {/* 1. HEADING & SUBTITLE */}
//         <div className="text-center max-w-sm mb-8">
//           <h3 className="text-3xl font-semibold leading-tight tracking-tight">
//             The Smartest Way to Manage Your Legal Cases.
//           </h3>
//           <p className="mt-4 text-sm text-gray-600 leading-relaxed">
//             Expand your reach, streamline your workflow, and get paid faster all in one smart legal tech suite.
//           </p>
//         </div>

//         {/* 2. LAPTOP MOCKUP */}
//         <div className="relative w-full flex justify-center mb-10 px-2">
//           <div className="relative outline outline-1 outline-gray-300/50 rounded-2xl p-3 w-full max-w-[480px]">
//             <div className="relative">
//               <img
//                 src="/laptoptrans.png"
//                 className="w-full drop-shadow-[0_40px_80px_rgba(0,0,0,0.35)]"
//               />
//               {/* Screen — shows the active feature image */}
//               <div className="absolute top-[26%] left-[17%] w-[66%] h-[44%] overflow-hidden rounded-xl bg-black">
//                 <motion.img
//                   key={active}
//                   src={FEATURES[active].image}
//                   className="w-full h-full object-cover"
//                   initial={{ opacity: 0 }}
//                   animate={{ opacity: 1 }}
//                   transition={{ duration: 0.4 }}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* 3. FEATURE GRID — 2 left, 2 right, last centered */}
//         <div className="w-full max-w-sm px-2">

//           {/* First 4 items: 2x2 grid */}
//           <div className="grid grid-cols-2 gap-3 mb-3">
//             {FEATURES.slice(0, 4).map((f, i) => (
//               <button
//                 key={i}
//                 type="button"
//                 onClick={() => setActive(i)}
//                 style={{
//                   opacity: active === i ? 1 : 0.45,
//                   transform: active === i ? "scale(1.03)" : "scale(1)",
//                   transition: "opacity 0.3s, transform 0.3s",
//                 }}
//                 className="flex items-center gap-2.5 px-4 py-3 rounded-xl bg-gray-50 border border-gray-100 shadow-sm w-full cursor-pointer"
//               >
//                 <div
//                   className={`w-2.5 h-2.5 rounded-full flex-shrink-0 transition-all duration-300 ${
//                     active === i
//                       ? "bg-gradient-to-r from-yellow-400 to-orange-400 shadow-[0_0_8px_rgba(255,180,50,0.7)]"
//                       : "bg-gray-300"
//                   }`}
//                 />
//                 <span
//                   className={`text-sm transition-all duration-300 ${
//                     active === i ? "font-semibold text-black" : "text-gray-700"
//                   }`}
//                 >
//                   {f.title}
//                 </span>
//               </button>
//             ))}
//           </div>

//           {/* 5th item: centered below */}
//           <div className="flex justify-center">
//             <button
//               type="button"
//               onClick={() => setActive(4)}
//               style={{
//                 opacity: active === 4 ? 1 : 0.45,
//                 transform: active === 4 ? "scale(1.03)" : "scale(1)",
//                 transition: "opacity 0.3s, transform 0.3s",
//                 width: "calc(50% - 6px)",
//               }}
//               className="flex items-center gap-2.5 px-4 py-3 rounded-xl bg-gray-50 border border-gray-100 shadow-sm cursor-pointer"
//             >
//               <div
//                 className={`w-2.5 h-2.5 rounded-full flex-shrink-0 transition-all duration-300 ${
//                   active === 4
//                     ? "bg-gradient-to-r from-yellow-400 to-orange-400 shadow-[0_0_8px_rgba(255,180,50,0.7)]"
//                     : "bg-gray-300"
//                 }`}
//               />
//               <span
//                 className={`text-sm transition-all duration-300 ${
//                   active === 4 ? "font-semibold text-black" : "text-gray-700"
//                 }`}
//               >
//                 {FEATURES[4].title}
//               </span>
//             </button>
//           </div>

//         </div>
//       </div>

//     </section>
//   );
// }



























// "use client";

// import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// import { useRef, useState, useEffect } from "react";

// const FEATURES = [
//   { title: "Dashboard", image: "homepage_dashboard.png" },
//   { title: "All Cases", image: "homepage_allcase.png" },
//   { title: "Calendar", image: "homepage_calander.png" },
//   { title: "Export Cases", image: "homepage_findcases.png" },
//   { title: "Expenses", image: "homepage_expenses.png" }
// ];

// export default function Features() {
//   const outerScrollRef = useRef(null);
//   const laptopScrollRef = useRef(null);
//   const [active, setActive] = useState(0);

//   const { scrollYProgress } = useScroll({
//     container: laptopScrollRef
//   });

//   const progressHeight = useSpring(
//     useTransform(scrollYProgress, [0, 1], ["0%", "100%"]),
//     { stiffness: 120, damping: 30 }
//   );

//   useEffect(() => {
//     const outer = outerScrollRef.current;
//     const laptop = laptopScrollRef.current;

//     if (!outer || !laptop) return;

//     const handleOuterScroll = () => {
//       const maxOuter = outer.scrollHeight - outer.clientHeight;
//       if (maxOuter <= 0) return;

//       let progress = outer.scrollTop / maxOuter;
//       progress = Math.min(Math.max(progress, 0), 1);

//       const maxLaptop = laptop.scrollHeight - laptop.clientHeight;
//       laptop.scrollTop = progress * maxLaptop;

//       const index = Math.round(progress * (FEATURES.length - 1));
//       setActive(index);
//     };
    

//     outer.addEventListener("scroll", handleOuterScroll);

//     return () => {
//       outer.removeEventListener("scroll", handleOuterScroll);
//     };
//   }, []);
//   // Auto-switch for mobile
//   useEffect(() => {
//     const isMobile = window.innerWidth < 1024;
//     if (!isMobile) return;

//     const interval = setInterval(() => {
//       setActive((prev) => (prev + 1) % FEATURES.length);
//     }, 2500);

//     return () => clearInterval(interval);
//   }, []);


//   return (
//     <section className="relative py-16 lg:py-20 bg-white overflow-hidden">
//       <style>{`
//         .hide-scrollbar::-webkit-scrollbar {
//           display: none;
//         }
//         .hide-scrollbar {
//           -ms-overflow-style: none;
//           scrollbar-width: none;
//         }
//       `}</style>

//       {/* ============ DESKTOP LAYOUT ============ */}
//       <div className="hidden lg:grid relative max-w-7xl mx-auto px-4 sm:px-6 lg:grid-cols-2 items-center gap-12 lg:gap-28">

//         {/* LEFT SIDE */}
//         <div className="max-w-md pt-10 lg:pt-20 text-center lg:text-left mx-auto lg:mx-0">

//           <h3 className="text-3xl sm:text-4xl lg:text-5xl font-semibold leading-tight tracking-tight">
//             The Smartest Way to Manage Your Legal Cases.
//           </h3>

//           <p className="mt-4 text-sm sm:text-base text-gray-600 leading-relaxed px-2 lg:px-0">
//             Expand your reach, streamline your workflow, and get paid faster all in one smart legal tech suite.
//           </p>

//           <div className="mt-8 space-y-4">
//             {FEATURES.map((f, i) => (
//               <motion.div
//                 key={i}
//                 animate={{
//                   opacity: active === i ? 1 : 0.4,
//                   x: active === i ? 14 : 0
//                 }}
//                 transition={{ duration: 0.35 }}
//                 onClick={() => {
//                   const outer = outerScrollRef.current;
//                   if (!outer) return;
//                   const maxOuter = outer.scrollHeight - outer.clientHeight;
//                   const target = (i / (FEATURES.length - 1)) * maxOuter;
//                   outer.scrollTo({ top: target, behavior: "smooth" });
//                 }}
//                 className="flex items-center justify-center lg:justify-start gap-3 cursor-pointer hover:opacity-80"
//               >
//                 <div
//                   className={`w-3 h-3 rounded-full transition-all duration-300 ${
//                     active === i
//                       ? "bg-gradient-to-r from-yellow-400 to-orange-400 shadow-[0_0_10px_rgba(255,180,50,0.7)]"
//                       : "bg-gray-300"
//                   }`}
//                 />
//                 <p
//                   className={`text-sm sm:text-base transition-all duration-300 ${
//                     active === i ? "font-semibold text-black" : "text-gray-800"
//                   }`}
//                 >
//                   {f.title}
//                 </p>
//               </motion.div>
//             ))}
//           </div>
//         </div>

//         {/* RIGHT SIDE */}
//         <div className="relative flex justify-center overflow-visible mt-10 lg:mt-0">

//           {/* SCROLL CONTROLLER */}
//           <div
//             ref={outerScrollRef}
//             className="relative h-[400px] sm:h-[500px] lg:h-[550px] w-full max-w-[900px] lg:-left-[100px] overflow-y-scroll hide-scrollbar"
//           >
//             <div className="h-[4000px]" />
//           </div>

//           {/* LAPTOP */}
//           <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
//             <div className="relative outline outline-1 outline-gray-300/50 rounded-2xl p-4 sm:p-6">
//               <motion.div
//                 initial={{ scale: 1 }}
//                 whileHover={{ scale: 1.12, rotateX: 10, rotateY: -10, y: -25 }}
//                 transition={{ type: "spring", stiffness: 200, damping: 20 }}
//                 style={{ perspective: 1400 }}
//               >
//                 <div className="relative">
//                   <img
//                     src="/laptoptrans.png"
//                     className="relative w-[320px] sm:w-[500px] lg:w-[750px] max-w-none drop-shadow-[0_60px_120px_rgba(0,0,0,0.45)] hover:drop-shadow-[0_80px_160px_rgba(0,0,0,0.55)] transition-all duration-500"
//                   />
//                   <div
//                     ref={laptopScrollRef}
//                     className="absolute top-[26%] left-[17%] w-[66%] h-[44%] overflow-y-auto rounded-xl bg-black hide-scrollbar shadow-inner border border-white/15 ring-1 ring-black/40"
//                   >
//                     {FEATURES.map((f, i) => (
//                       <img key={i} src={f.image} className="w-full h-full object-cover" />
//                     ))}
//                   </div>
//                 </div>
//               </motion.div>
//             </div>
//           </div>

//           {/* PROGRESS BAR */}
//           <div className="hidden lg:block absolute right-[-35px] top-1/2 -translate-y-1/2 h-[340px] w-[3px] bg-gray-200 rounded-full overflow-hidden">
//             <motion.div className="w-full bg-black" style={{ height: progressHeight }} />
//           </div>

//         </div>
//       </div>

//    {/* ============ MOBILE LAYOUT ============ */}
// <div className="lg:hidden flex flex-col items-center pt-12 mt-4 pb-10">

//   {/* 1. HEADING & SUBTITLE */}
//   <div className="text-center max-w-sm px-5 mb-0">
//     <h3 className="text-[26px] font-bold leading-tight tracking-tight text-gray-950">
//       The Smartest Way to Manage Your Legal Cases.
//     </h3>
//     <p className="mt-3 text-[13.5px] text-gray-500 leading-relaxed">
//       Expand your reach, streamline your workflow, and get paid faster all in one smart legal tech suite.
//     </p>
//   </div>

//   {/* 2. LAPTOP — larger */}
//   <div className="relative w-full max-w-[640px] mt-2 mb-2 px-0">
//     <img
//       src="/laptoptrans.png"
//       className="w-full block drop-shadow-[0_40px_80px_rgba(0,0,0,0.28)]"
//     />
//     <div className="absolute top-[26.5%] left-[17.2%] w-[65.6%] h-[43.5%] overflow-hidden rounded-lg bg-black">
//       <motion.img
//         key={active}
//         src={FEATURES[active].image}
//         className="w-full h-full object-cover"
//         initial={{ opacity: 0 }}
//         animate={{ opacity: 1 }}
//         transition={{ duration: 0.4 }}
//       />
//     </div>
//   </div>

//   {/* 3. FEATURE GRID — 3 left col, 2 right col, both top-aligned */}
//   <div className="w-full max-w-[420px] px-[18px]">
//     <div className="flex gap-[10px] items-start">

//       {/* LEFT COLUMN — Dashboard, Calendar, Expenses */}
//       <div className="flex flex-col gap-[10px] flex-1">
//         {[0, 2, 4].map((i) => (
//           <button
//             key={i}
//             type="button"
//             onClick={() => setActive(i)}
//             className={`flex items-center gap-[10px] px-4 py-[13px] rounded-2xl border text-left w-full cursor-pointer transition-all duration-300
//               ${active === i
//                 ? "bg-amber-50 border-amber-400 shadow-[0_4px_20px_rgba(245,158,11,0.18)] scale-[1.03]"
//                 : "bg-[#fafafa] border-gray-200 opacity-50"
//               }`}
//           >
//             <div className={`w-[9px] h-[9px] rounded-full flex-shrink-0 transition-all duration-300
//               ${active === i
//                 ? "bg-gradient-to-br from-yellow-400 to-orange-400 shadow-[0_0_8px_rgba(245,158,11,0.6)]"
//                 : "bg-gray-300"
//               }`}
//             />
//             <span className={`text-[13px] transition-all duration-300 ${active === i ? "font-bold text-amber-900" : "font-medium text-gray-600"}`}>
//               {FEATURES[i].title}
//             </span>
//           </button>
//         ))}
//       </div>

//       {/* RIGHT COLUMN — All Cases, Export Cases (top-aligned, with top margin to align with Dashboard) */}
//       <div className="flex flex-col gap-[10px] flex-1 mt-0">
//         {[1, 3].map((i) => (
//           <button
//             key={i}
//             type="button"
//             onClick={() => setActive(i)}
//             className={`flex items-center gap-[10px] px-4 py-[13px] rounded-2xl border text-left w-full cursor-pointer transition-all duration-300
//               ${active === i
//                 ? "bg-amber-50 border-amber-400 shadow-[0_4px_20px_rgba(245,158,11,0.18)] scale-[1.03]"
//                 : "bg-[#fafafa] border-gray-200 opacity-50"
//               }`}
//           >
//             <div className={`w-[9px] h-[9px] rounded-full flex-shrink-0 transition-all duration-300
//               ${active === i
//                 ? "bg-gradient-to-br from-yellow-400 to-orange-400 shadow-[0_0_8px_rgba(245,158,11,0.6)]"
//                 : "bg-gray-300"
//               }`}
//             />
//             <span className={`text-[13px] transition-all duration-300 ${active === i ? "font-bold text-amber-900" : "font-medium text-gray-600"}`}>
//               {FEATURES[i].title}
//             </span>
//           </button>
//         ))}
//       </div>

//     </div>
//   </div>
// </div>
//     </section>
//   );
// }




















"use client";

import { motion, useScroll, useTransform, useSpring } from "framer-motion";
import { useRef, useState, useEffect, useCallback } from "react";

const FEATURES = [
  { title: "Dashboard", image: "homepage_dashboard.jpg" },
  { title: "All Cases", image: "homepage_allcase.jpg" },
  { title: "Calendar", image: "homepage_calander.jpg" },
  { title: "Export Cases", image: "homepage_findcases.jpg" },
  { title: "Expenses", image: "homepage_expenses1.jpg" }
];

export default function Features() {
  const outerScrollRef = useRef(null);
  const laptopScrollRef = useRef(null);
  const mobileIntervalRef = useRef(null);
  const [active, setActive] = useState(0);

  const { scrollYProgress } = useScroll({ container: laptopScrollRef });

  const progressHeight = useSpring(
    useTransform(scrollYProgress, [0, 1], ["0%", "100%"]),
    { stiffness: 120, damping: 30 }
  );

  useEffect(() => {
    const outer = outerScrollRef.current;
    const laptop = laptopScrollRef.current;
    if (!outer || !laptop) return;

    const handleOuterScroll = () => {
      const maxOuter = outer.scrollHeight - outer.clientHeight;
      if (maxOuter <= 0) return;
      let progress = outer.scrollTop / maxOuter;
      progress = Math.min(Math.max(progress, 0), 1);
      const maxLaptop = laptop.scrollHeight - laptop.clientHeight;
      laptop.scrollTop = progress * maxLaptop;
      const index = Math.round(progress * (FEATURES.length - 1));
      setActive(index);
    };

    outer.addEventListener("scroll", handleOuterScroll);
    return () => outer.removeEventListener("scroll", handleOuterScroll);
  }, []);

  // ── Mobile auto-cycle ──────────────────────────────────────────
  const startMobileCycle = useCallback(() => {
    if (window.innerWidth >= 1024) return;
    clearInterval(mobileIntervalRef.current);
    mobileIntervalRef.current = setInterval(() => {
      setActive((prev) => (prev + 1) % FEATURES.length);
    }, 2500);
  }, []);

  useEffect(() => {
    startMobileCycle();
    return () => clearInterval(mobileIntervalRef.current);
  }, [startMobileCycle]);

  // Manual tap — switch immediately + restart timer
  const handleMobileTap = (i) => {
    setActive(i);
    startMobileCycle();
  };
  // ──────────────────────────────────────────────────────────────

  return (
    <section className="relative py-16 lg:py-20 bg-white overflow-hidden">
      <style>{`
        .hide-scrollbar::-webkit-scrollbar { display: none; }
        .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>

      {/* ============ DESKTOP LAYOUT ============ */}
      <div className="hidden lg:grid relative max-w-7xl mx-auto px-4 sm:px-6 lg:grid-cols-2 items-center gap-8 lg:gap-10 xl:gap-28">

        {/* LEFT SIDE */}
        <div className="max-w-[320px] pt-8 lg:pt-5 text-center lg:text-left mx-auto lg:mx-0 lg:ml-6 xl:ml-0">
          <h3 className="text-3xl sm:text-4xl lg:text-[28px] xl:text-5xl font-semibold leading-tight tracking-tight">
            The Smartest Way to Manage Your Legal Cases.
          </h3>
          <p className="mt-4 text-sm sm:text-base text-gray-600 leading-relaxed px-2 lg:px-0">
            Expand your reach, streamline your workflow, and get paid faster all in one smart legal tech suite.
          </p>

          <div className="mt-8 space-y-4">
            {FEATURES.map((f, i) => (
              <motion.div
                key={i}
                animate={{ opacity: active === i ? 1 : 0.4, x: active === i ? 14 : 0 }}
                transition={{ duration: 0.35 }}
                onClick={() => {
                  const outer = outerScrollRef.current;
                  if (!outer) return;
                  const maxOuter = outer.scrollHeight - outer.clientHeight;
                  const target = (i / (FEATURES.length - 1)) * maxOuter;
                  outer.scrollTo({ top: target, behavior: "smooth" });
                }}
                className="flex items-center justify-center lg:justify-start gap-3 cursor-pointer hover:opacity-80"
              >
                <div className={`w-3 h-3 rounded-full transition-all duration-300 ${
                  active === i
                    ? "bg-gradient-to-r from-yellow-400 to-orange-400 shadow-[0_0_10px_rgba(255,180,50,0.7)]"
                    : "bg-gray-300"
                }`} />
                <p className={`text-sm sm:text-base transition-all duration-300 ${
                  active === i ? "font-semibold text-black" : "text-gray-800"
                }`}>
                  {f.title}
                </p>
              </motion.div>
            ))}
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="relative flex justify-center overflow-visible mt-10 lg:mt-8 lg:-ml-12">
          <div
            ref={outerScrollRef}
            className="relative h-[400px] sm:h-[500px] lg:h-[550px] w-full max-w-[900px] lg:-left-[170px] xl:-left-[130px] overflow-y-scroll hide-scrollbar"
          >
            <div className="h-[4000px]" />
          </div>

          <div className="absolute inset-0 flex items-center justify-center pointer-events-none lg:translate-x-[-60px] xl:translate-x-[-50px] lg:translate-y-[0px] xl:translate-y-[10px] ">
            <div className="relative rounded-2xl p-4 sm:p-6">
              <motion.div
                initial={{ scale: 1 }}
                whileHover={{ scale: 1.12, rotateX: 10, rotateY: -10, y: -25 }}
                transition={{ type: "spring", stiffness: 200, damping: 20 }}
                style={{ perspective: 1400 }}
              >
                <div className="relative">
                  <img
                    src="/laptoptrans.png"
                    className="relative w-[400px] sm:w-[650px] lg:w-[800px] xl:w-[950px] max-w-none drop-shadow-[0_60px_120px_rgba(0,0,0,0.45)] hover:drop-shadow-[0_80px_160px_rgba(0,0,0,0.55)] transition-all duration-500"
                  />
                  <div
                    ref={laptopScrollRef}
                    className="absolute top-[26%] left-[17%] w-[66%] h-[44%] overflow-y-auto rounded-xl bg-black hide-scrollbar shadow-inner border border-white/15 ring-1 ring-black/40"
                  >
                    {FEATURES.map((f, i) => (
                      <img key={i} src={f.image} className="w-full h-full object-cover" />
                    ))}
                  </div>
                </div>
              </motion.div>
            </div>
          </div>

          <div className="hidden lg:block absolute right-[-35px] top-1/2 -translate-y-1/2 h-[340px] w-[3px] bg-gray-200 rounded-full overflow-hidden">
            <motion.div className="w-full bg-black" style={{ height: progressHeight }} />
          </div>
        </div>
      </div>

     {/* ============ MOBILE LAYOUT ============ */}
{/* <div className="lg:hidden flex flex-col items-center pt-16 pb-10"> */}
<div className="lg:hidden flex flex-col items-center pt-16 pb-0 gap-0">

  {/* 1. HEADING & SUBTITLE */}
  <div className="text-center max-w-sm px-5 mb-4">
    <h3 className="text-[26px] font-bold leading-tight tracking-tight text-gray-950">
      The Smartest Way to Manage Your Legal Cases.
    </h3>
    <p className="mt-3 text-[13.5px] text-gray-500 leading-relaxed">
      Expand your reach, streamline your workflow, and get paid faster all in one smart legal tech suite.
    </p>
  </div>

  {/* 2. PILL CARD — Option C style, auto-cycles above laptop */}
  {/* <div className="w-full max-w-[360px] px-5">

   
    <motion.div
      key={active}
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.28 }}
      className="flex items-center gap-[10px] bg-amber-50 border-[1.5px] border-amber-300 rounded-full px-3 py-[9px] pr-4"
    > */}
    {/* 2. PILL CARD */}
<div className="w-full max-w-[360px] px-5">
  <motion.div
  key={active}
  initial={{ opacity: 0, y: 6 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.28 }}
  style={{ background: "#fdf8ee", border: "1px solid #e8d5a3" }}
  className="flex items-center gap-[10px] rounded-full px-3 py-[9px] pr-4"
>
  <div
    style={{ background: "#e8c97a" }}
    className="w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0"
  >
        {/* Icon per feature */}
        {active === 0 && (
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
            <rect x="3" y="3" width="7" height="7" rx="1" fill="#fff"/>
            <rect x="14" y="3" width="7" height="7" rx="1" fill="#fff"/>
            <rect x="3" y="14" width="7" height="7" rx="1" fill="#fff"/>
            <rect x="14" y="14" width="7" height="7" rx="1" fill="#fff"/>
          </svg>
        )}
        {active === 1 && (
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
            <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 012-2h2a2 2 0 012 2M9 5h6" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
            <path d="M9 12h6M9 16h4" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        )}
        {active === 2 && (
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
            <rect x="3" y="4" width="18" height="18" rx="2" stroke="#fff" strokeWidth="2"/>
            <path d="M3 9h18M8 2v4M16 2v4" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        )}
        {active === 3 && (
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
            <path d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5 5-5M12 3v12" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        )}
        {active === 4 && (
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
            <path d="M12 2v20M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        )}
      </div>

      {/* <span className="text-[13.5px] font-bold text-amber-900 flex-1"> */}
      <span className="text-[13.5px] font-bold text-amber-700 flex-1">
        {FEATURES[active].title}
      </span>

      {/* Progress dots */}
      <div className="flex items-center gap-[5px] ml-auto">
        {FEATURES.map((_, i) => (
          <button
            key={i}
            type="button"
            onClick={() => handleMobileTap(i)}
            // className={`rounded-full transition-all duration-300 ${
            //   active === i
            //     ? "w-4 h-[6px] bg-amber-400"
            //     : "w-[6px] h-[6px] bg-amber-200"
            // }`}
            className={`rounded-full transition-all duration-300 ${
  active === i
    ? "w-4 h-[6px] bg-amber-300"
    : "w-[6px] h-[6px] bg-amber-100"
}`}
          />
        ))}
      </div>
    </motion.div>
  </div>

  {/* 3. LAPTOP — right below pill, minimal gap */}
  {/* <div className="relative w-full max-w-[580px] mt-3 px-0"> */}
  {/* <div className="relative w-full max-w-[580px] -mt-1 px-0"> */}
  {/* <div className="relative w-full max-w-[580px] -mt-14 px-0"> */}
  <div className="relative w-full max-w-[580px] -mt-14 -mb-5 px-0">
    <img
      src="/laptoptrans.png"
      className="w-full block drop-shadow-[0_30px_60px_rgba(0,0,0,0.22)]"
    />
    <div className="absolute top-[26.5%] left-[17.2%] w-[65.6%] h-[43.5%] overflow-hidden rounded-lg bg-black">
      <motion.img
        key={active}
        src={FEATURES[active].image}
        className="w-full h-full object-cover"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4 }}
      />
    </div>
  </div>

</div>
    </section>
  );
}
